// Extended mock data for Redspire Civil Engineering Website

export const companyInfo = {
  name: "Redspire Civil Engineering",
  tagline: "Engineering Strength. Building Tomorrow.",
  logo: "REDSPIRE",
  logoUrl: "https://dummyimage.com/512x512/cc1c1c/ffffff.png&text=R",
  website: "https://redspire.com",
  phone: "+1 (203) 496-3375",
  email: "info@redspire.com",
  address: "218 Brookside Industrial Park, Stamford, CT 06902",
  country: "United States",
  socialLinks: {
    linkedin: "https://linkedin.com",
    twitter: "https://twitter.com",
    facebook: "https://facebook.com"
  }
};

export const navigation = [
  { name: "About", href: "/about" },
  { 
    name: "Services", 
    href: "/services",
    hasDropdown: true,
    children: [
      { name: "Infrastructure Development", href: "/services/infrastructure-development" },
      { name: "Structural Engineering", href: "/services/structural-engineering" },
      { name: "Civil Construction Management", href: "/services/civil-construction-management" },
      { name: "Geotechnical & Environmental", href: "/services/geotechnical-environmental" },
      { name: "Utilities & Underground Works", href: "/services/utilities-underground" },
      { name: "Design-Build Solutions", href: "/services/design-build" },
      { name: "Transportation Engineering", href: "/services/transportation-engineering" },
      { name: "Water Resources Engineering", href: "/services/water-resources" },
      { name: "Land Development & Site Engineering", href: "/services/land-development" },
      { name: "Construction Materials Testing", href: "/services/materials-testing" },
      { name: "3D Modelling & Digital Twin", href: "/services/digital-twin" }
    ]
  },
  { name: "Projects", href: "/projects" },
  { name: "Locations", href: "/locations" },
  { name: "News", href: "/news" },
  { name: "Careers", href: "/careers" },
  { name: "Contact", href: "/contact" }
];

export const locations = [
  {
    id: "stamford",
    name: "Northeast Operations HQ",
    city: "Stamford, Connecticut",
    address: "218 Brookside Industrial Park, Stamford, CT 06902",
    phone: "+1 (203) 496-3375",
    email: "hq@redspire.com",
    hours: "Mon–Fri • 8:00am–6:00pm ET",
    regionalFocus: "Program leadership for the Northeast corridor, major bridge replacements, and water resources modernization.",
    leadership: "Maya Lorne, Chief Operating Officer",
    services: [
      "Program & construction management",
      "Bridge and structural engineering",
      "Water resources & resiliency"
    ],
    mapUrl: "https://maps.google.com/?q=218+Brookside+Industrial+Park,+Stamford,+CT+06902",
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1200&q=80"
  },
  {
    id: "salt-lake-city",
    name: "Mountain West Division",
    city: "Salt Lake City, Utah",
    address: "222 S Main Street, Suite 500, Salt Lake City, UT 84101",
    phone: "+1 (801) 692-4180",
    email: "slc@redspire.com",
    hours: "Mon–Fri • 8:00am–6:00pm MT",
    regionalFocus: "Highway modernization, mining infrastructure, water conservation systems, and rapid-transit expansion across the Intermountain West.",
    leadership: "Nathan Reeves, Regional Director",
    services: [
      "Highway & interchange engineering",
      "Water conservation & irrigation systems",
      "Mining & industrial infrastructure"
    ],
    mapUrl: "https://maps.google.com/?q=222+S+Main+St,+Suite+500,+Salt+Lake+City,+UT+84101",
    image: "https://images.unsplash.com/photo-1622396636133-f4f28c059912?w=1200&q=80"
  },
  {
    id: "dallas",
    name: "Central Delivery Studio",
    city: "Dallas, Texas",
    address: "8700 N Stemmons Fwy, Suite 400, Dallas, TX 75247",
    phone: "+1 (512) 434-8560",
    email: "dallas@redspire.com",
    hours: "Mon–Fri • 8:00am–6:00pm CT",
    regionalFocus: "High-capacity transit, river crossings, and mobility corridors across Texas and the Gulf Coast.",
    leadership: "Jonas Hale, Director of Engineering",
    services: [
      "Transportation corridor delivery",
      "Digital design coordination",
      "Construction-phase engineering support"
    ],
    mapUrl: "https://maps.google.com/?q=8700+N+Stemmons+Fwy,+Suite+400,+Dallas,+TX+75247",
    image: "https://images.unsplash.com/photo-1500534623283-312aade485b7?w=1200&q=80"
  },
  {
    id: "los-angeles",
    name: "West Coast Resilience Hub",
    city: "Los Angeles, California",
    address: "555 W 5th Street, 35th Floor, Los Angeles, CA 90013",
    phone: "+1 (213) 873-5524",
    email: "la@redspire.com",
    hours: "Mon–Fri • 8:00am–6:00pm PT",
    regionalFocus: "Seismic retrofits, coastal resilience, and advanced utility programs throughout California.",
    leadership: "Elena Farrow, Director of Safety & Compliance",
    services: [
      "Seismic and coastal engineering",
      "Utility hardening & underground works",
      "Sustainability & environmental compliance"
    ],
    mapUrl: "https://maps.google.com/?q=555+W+5th+St,+Los+Angeles,+CA+90013",
    image: "https://images.unsplash.com/photo-1504208434309-cb69f4fe52b0?w=1200&q=80"
  }
];

export const heroSlides = [
  {
    id: 1,
    title: "Engineering Strength. Building Tomorrow.",
    subtitle: "Delivering civil infrastructure solutions that strengthen communities and advance mobility for generations.",
    image: "https://images.unsplash.com/photo-1536895058696-a69b1c7ba34f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxjaXZpbCUyMGVuZ2luZWVyaW5nfGVufDB8fHx8MTc2NDE0MzU2OHww&ixlib=rb-4.1.0&q=85",
    cta: { text: "Explore Our Projects", href: "/projects" }
  },
  {
    id: 2,
    title: "Infrastructure with Purpose",
    subtitle: "From concept to completion, we build the foundations that power progress.",
    image: "https://images.unsplash.com/photo-1529926691761-20fb82067c71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxpbmZyYXN0cnVjdHVyZXxlbnwwfHx8fDE3NjQxNDM1NzN8MA&ixlib=rb-4.1.0&q=85",
    cta: { text: "Our Services", href: "/services" }
  },
  {
    id: 3,
    title: "Where Precision Meets Progress",
    subtitle: "Technical excellence combined with innovative solutions for complex engineering challenges.",
    image: "https://images.unsplash.com/photo-1527335988388-b40ee248d80c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxpbmZyYXN0cnVjdHVyZXxlbnwwfHx8fDE3NjQxNDM1NzN8MA&ixlib=rb-4.1.0&q=85",
    cta: { text: "Join Our Team", href: "/careers" }
  }
];

export const servicesData = {
  "infrastructure-development": {
    id: "infrastructure-development",
    title: "Infrastructure Development",
    shortDescription: "Comprehensive planning and execution of large-scale infrastructure projects including highways, transit systems, and public facilities.",
    icon: "Building2",
    heroImage: "https://images.unsplash.com/photo-1536099629323-44806c1ea264?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80",
    seo: {
      title: "Infrastructure Development Services | Redspire Engineering",
      description: "Expert infrastructure development services in Connecticut. Highways, transit systems, bridges, and public facilities engineered for durability and community impact.",
      keywords: ["infrastructure development", "highway construction", "transit systems", "civil engineering Connecticut"]
    },
    overview: "Redspire delivers comprehensive infrastructure development services that transform communities and enable economic growth. From initial feasibility studies through final construction, our team brings European engineering precision to every project, ensuring infrastructure that serves communities for generations.",
    whatIncludes: [
      "Master planning and feasibility analysis",
      "Environmental impact assessments",
      "Right-of-way acquisition support",
      "Design development and engineering",
      "Construction management and oversight",
      "Quality assurance and commissioning",
      "Lifecycle cost analysis",
      "Stakeholder coordination and public engagement"
    ],
    coreCapabilities: [
      { title: "Highway & Roadway Systems", description: "Design and construction of arterial roads, expressways, and interstate connections with focus on safety and traffic flow optimization." },
      { title: "Transit Infrastructure", description: "Bus rapid transit corridors, light rail systems, and multimodal transportation hubs serving growing communities." },
      { title: "Bridge & Overpass Structures", description: "Cable-stayed, suspension, and beam bridges designed for seismic resilience and extended service life." },
      { title: "Public Facilities", description: "Civic buildings, municipal centers, and community infrastructure supporting essential public services." }
    ],
    technicalApproach: "Our infrastructure development methodology combines rigorous engineering analysis with practical construction expertise. We begin with comprehensive site assessments and geotechnical investigations, then develop solutions that balance technical performance, construction feasibility, and long-term maintenance requirements. Every project benefits from our integrated design-build capabilities, allowing seamless coordination between engineering teams and field operations.",
    toolsAndMethods: [
      "Building Information Modeling (BIM) for 3D coordination",
      "Geographic Information Systems (GIS) for spatial analysis",
      "Traffic simulation and modeling software",
      "Finite element analysis for structural optimization",
      "Lifecycle cost analysis tools",
      "Environmental modeling platforms"
    ],
    projectTypes: [
      "Interstate highway expansions and rehabilitations",
      "Urban arterial road improvements",
      "Bus rapid transit corridors",
      "Pedestrian and cycling infrastructure",
      "Airport access roads and facilities",
      "Industrial park infrastructure"
    ],
    caseExample: {
      title: "Regional Transit Corridor Modernization",
      description: "Redspire led the comprehensive modernization of a 15-kilometer transit corridor serving over 180,000 daily passengers. The project included elevated track sections, six new accessible stations, integrated parking facilities, and real-time passenger information systems. Completed ahead of schedule, the corridor now operates with 40% improved travel times and has catalyzed significant economic development along its route."
    },
    whyMatters: "Infrastructure forms the backbone of economic prosperity and quality of life. Well-designed transportation networks reduce commute times, lower vehicle emissions, and connect communities to employment, education, and healthcare. At Redspire, we understand that every infrastructure investment shapes how communities grow and thrive for decades to come.",
    howDelivers: "Redspire approaches every infrastructure project as a partnership with our clients and communities. We assign dedicated project teams with deep experience in similar work, maintain transparent communication throughout the project lifecycle, and leverage our construction expertise to identify value engineering opportunities that reduce costs without compromising quality.",
    images: [
      { src: "https://images.unsplash.com/photo-1536099629323-44806c1ea264?w=800", alt: "Highway infrastructure under construction" },
      { src: "https://images.unsplash.com/photo-1519043916581-33ecfdba3b1c?w=800", alt: "Modern transit station design" }
    ]
  },
  "structural-engineering": {
    id: "structural-engineering",
    title: "Structural Engineering",
    shortDescription: "Expert structural analysis and design services for bridges, buildings, and industrial structures ensuring safety and longevity.",
    icon: "Layers",
    heroImage: "https://images.unsplash.com/photo-1529926691761-20fb82067c71?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80",
    seo: {
      title: "Structural Engineering Services | Redspire Civil Engineering",
      description: "Professional structural engineering for bridges, buildings, and industrial structures. Seismic design, load analysis, and structural assessments in Connecticut.",
      keywords: ["structural engineering", "bridge design", "seismic engineering", "structural analysis"]
    },
    overview: "Redspire's structural engineering team delivers innovative solutions for complex load-bearing challenges. Our engineers combine advanced analytical methods with practical construction knowledge, ensuring structures that perform reliably under all anticipated conditions while remaining economical to build and maintain.",
    whatIncludes: [
      "Structural concept development and analysis",
      "Load calculations and safety factor determination",
      "Seismic and wind load design",
      "Foundation and substructure engineering",
      "Connection and detailing design",
      "Construction document preparation",
      "Shop drawing review and approval",
      "Construction observation and certification"
    ],
    coreCapabilities: [
      { title: "Bridge Engineering", description: "Complete bridge design services from concept through construction, including cable-stayed, arch, and beam structures." },
      { title: "Building Structures", description: "Commercial, industrial, and institutional building structural systems optimized for performance and economy." },
      { title: "Industrial Facilities", description: "Heavy industrial structures including processing plants, warehouses, and manufacturing facilities." },
      { title: "Structural Assessments", description: "Condition evaluations, load rating analyses, and rehabilitation recommendations for existing structures." }
    ],
    technicalApproach: "Our structural engineering practice is founded on rigorous analytical methods validated through decades of successful projects. We utilize advanced finite element modeling to understand complex structural behaviors, then verify designs through independent calculations and peer review. Every structure we design meets or exceeds applicable codes while optimizing material usage and constructability.",
    toolsAndMethods: [
      "SAP2000 and ETABS for structural analysis",
      "STAAD.Pro for complex loading scenarios",
      "Revit Structure for BIM coordination",
      "LARSA 4D for bridge analysis",
      "RAM Structural System for building design",
      "Non-destructive testing equipment for assessments"
    ],
    projectTypes: [
      "Highway and pedestrian bridges",
      "High-rise building structures",
      "Parking structures and garages",
      "Industrial warehouse facilities",
      "Seismic retrofit and strengthening",
      "Structural rehabilitation projects"
    ],
    caseExample: {
      title: "Cable-Stayed River Crossing",
      description: "Redspire provided structural engineering services for a 720-meter cable-stayed bridge spanning a major river. The design incorporated seismic isolation bearings, wind dampers, and redundant cable systems. Our team optimized the deck section to reduce steel tonnage by 15% while maintaining full load capacity. The bridge now serves as a regional landmark and vital transportation link."
    },
    whyMatters: "Structural integrity is non-negotiable in civil engineering. Every building, bridge, and facility must safely support its intended loads throughout its service life, withstanding natural forces and unforeseen events. Redspire's structural engineering expertise provides the foundation for infrastructure that communities can trust.",
    howDelivers: "We assign licensed professional engineers to lead every structural project, supported by experienced designers and drafters. Our quality assurance process includes independent design checks, constructability reviews with our construction team, and field verification during construction. Clients receive clear documentation and responsive support throughout the project.",
    images: [
      { src: "https://images.unsplash.com/photo-1529926691761-20fb82067c71?w=800", alt: "Cable-stayed bridge structure" },
      { src: "https://images.unsplash.com/photo-1485083269755-a7b559a4fe5e?w=800", alt: "Steel structural framework" }
    ]
  },
  "civil-construction-management": {
    id: "civil-construction-management",
    title: "Civil Construction Management",
    shortDescription: "Full-service construction management from project inception through completion with rigorous quality control.",
    icon: "HardHat",
    heroImage: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80",
    seo: {
      title: "Civil Construction Management | Redspire Engineering CT",
      description: "Professional construction management services for civil infrastructure projects. Schedule control, quality assurance, and cost management expertise.",
      keywords: ["construction management", "civil construction", "project management", "quality control"]
    },
    overview: "Redspire's construction management services ensure that complex civil projects are delivered on time, within budget, and to exacting quality standards. Our experienced construction managers bring hands-on field knowledge combined with sophisticated project controls, providing owners with confidence and transparency throughout the construction process.",
    whatIncludes: [
      "Pre-construction planning and scheduling",
      "Contractor procurement and evaluation",
      "Budget development and cost control",
      "Schedule development and monitoring",
      "Quality assurance and inspection",
      "Safety program oversight",
      "Change order management",
      "Project closeout and documentation"
    ],
    coreCapabilities: [
      { title: "Program Management", description: "Multi-project coordination and resource optimization for large infrastructure programs." },
      { title: "Construction Oversight", description: "Daily field presence ensuring work meets specifications, schedules, and safety requirements." },
      { title: "Cost Management", description: "Budget tracking, payment processing, and value engineering to maximize project value." },
      { title: "Quality Control", description: "Comprehensive testing and inspection programs ensuring specification compliance." }
    ],
    technicalApproach: "Our construction management methodology emphasizes proactive issue identification and resolution. We establish clear communication protocols, maintain detailed project documentation, and use earned value management to track progress against baselines. Regular risk assessments identify potential problems before they impact schedules or budgets.",
    toolsAndMethods: [
      "Primavera P6 for schedule management",
      "Procore for project documentation",
      "Bluebeam for plan review and markup",
      "Cost tracking and forecasting systems",
      "Mobile inspection and reporting applications",
      "Drone surveying for progress documentation"
    ],
    projectTypes: [
      "Highway and bridge construction",
      "Water and wastewater facilities",
      "Transit system construction",
      "Site development projects",
      "Public works improvements",
      "Industrial facility construction"
    ],
    caseExample: {
      title: "Regional Water Treatment Facility",
      description: "Redspire provided construction management services for a major regional water treatment facility serving 200,000 residents. Our team coordinated 15 prime contractors, managed a complex equipment procurement program, and maintained quality oversight across mechanical, electrical, and structural work. The project completed three months ahead of schedule with zero lost-time safety incidents."
    },
    whyMatters: "Construction projects involve countless decisions, coordination challenges, and potential risks. Professional construction management provides the expertise and oversight needed to navigate these complexities, protecting owner interests and ensuring successful project outcomes.",
    howDelivers: "Redspire assigns experienced construction managers who understand both engineering principles and field realities. We establish clear project controls from day one, maintain constant communication with all stakeholders, and address issues promptly and decisively. Our construction background gives us credibility with contractors and insight into practical solutions.",
    images: [
      { src: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=800", alt: "Construction management team on site" },
      { src: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800", alt: "Project coordination meeting" }
    ]
  },
  "geotechnical-environmental": {
    id: "geotechnical-environmental",
    title: "Geotechnical & Environmental Services",
    shortDescription: "Soil analysis, environmental assessments, and sustainable engineering solutions for responsible development.",
    icon: "Mountain",
    heroImage: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80",
    seo: {
      title: "Geotechnical & Environmental Engineering | Redspire CT",
      description: "Comprehensive geotechnical investigations and environmental assessments. Soil analysis, foundation recommendations, and sustainable site development.",
      keywords: ["geotechnical engineering", "environmental assessment", "soil analysis", "site investigation"]
    },
    overview: "Redspire provides integrated geotechnical and environmental services that form the foundation for successful civil projects. Our subsurface investigations and environmental assessments identify site conditions, constraints, and opportunities, enabling informed design decisions and regulatory compliance.",
    whatIncludes: [
      "Subsurface exploration and sampling",
      "Laboratory soil and rock testing",
      "Foundation design recommendations",
      "Slope stability analysis",
      "Phase I and Phase II environmental assessments",
      "Remediation design and oversight",
      "Groundwater monitoring",
      "Regulatory permitting support"
    ],
    coreCapabilities: [
      { title: "Geotechnical Investigation", description: "Comprehensive subsurface exploration using borings, test pits, and geophysical methods." },
      { title: "Foundation Engineering", description: "Design recommendations for shallow and deep foundations, including piles and drilled shafts." },
      { title: "Environmental Assessment", description: "Phase I and II site assessments identifying contamination and regulatory compliance requirements." },
      { title: "Remediation Services", description: "Contaminated site cleanup design, implementation oversight, and regulatory closure." }
    ],
    technicalApproach: "Our geotechnical investigations are designed to answer specific engineering questions while optimizing exploration costs. We analyze site geology, review historical data, and develop focused investigation programs that provide the information needed for confident design decisions. Environmental assessments follow established protocols while incorporating practical remediation considerations.",
    toolsAndMethods: [
      "Hollow-stem auger and rotary drilling",
      "Cone penetration testing (CPT)",
      "Standard penetration testing (SPT)",
      "Geophysical survey equipment",
      "Accredited laboratory testing",
      "Groundwater monitoring well installation"
    ],
    projectTypes: [
      "Building and bridge foundations",
      "Retaining wall and slope design",
      "Landfill and containment facilities",
      "Brownfield redevelopment",
      "Underground construction",
      "Waterfront and marine structures"
    ],
    caseExample: {
      title: "Brownfield Industrial Redevelopment",
      description: "Redspire conducted comprehensive environmental and geotechnical investigations for a 45-acre former industrial site targeted for mixed-use redevelopment. Our Phase II assessment identified petroleum and solvent contamination requiring remediation. We designed an in-situ treatment system that achieved regulatory closure within 18 months, enabling the project to proceed on schedule."
    },
    whyMatters: "Understanding subsurface conditions is essential for safe and economical construction. Geotechnical investigations prevent costly surprises during construction, while environmental assessments protect human health and enable responsible redevelopment of impacted properties.",
    howDelivers: "Redspire maintains in-house drilling capabilities and laboratory partnerships for rapid turnaround of geotechnical data. Our environmental scientists navigate complex regulatory frameworks, working with agencies to achieve practical solutions. We provide clear recommendations that translate technical findings into actionable design guidance.",
    images: [
      { src: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800", alt: "Geotechnical drilling operation" },
      { src: "https://images.unsplash.com/photo-1581094288338-2314dddb7ece?w=800", alt: "Environmental soil sampling" }
    ]
  },
  "utilities-underground": {
    id: "utilities-underground",
    title: "Utilities & Underground Works",
    shortDescription: "Design and construction of water, sewer, electrical, and telecommunications infrastructure systems.",
    icon: "Pipette",
    heroImage: "https://images.pexels.com/photos/1057858/pexels-photo-1057858.jpeg?w=1920",
    seo: {
      title: "Utilities & Underground Infrastructure | Redspire Engineering",
      description: "Complete utility infrastructure services including water, sewer, stormwater, and telecommunications. Expert underground construction in Connecticut.",
      keywords: ["utility engineering", "underground construction", "water infrastructure", "sewer systems"]
    },
    overview: "Redspire designs and constructs the essential utility infrastructure that modern communities depend upon. From municipal water systems to fiber optic networks, our utility engineering team delivers reliable infrastructure that serves communities for decades while minimizing disruption during construction.",
    whatIncludes: [
      "Water distribution system design",
      "Sanitary sewer collection systems",
      "Stormwater management facilities",
      "Utility relocation coordination",
      "Trenchless technology applications",
      "Pump station design",
      "Telecommunications conduit systems",
      "Utility master planning"
    ],
    coreCapabilities: [
      { title: "Water Systems", description: "Distribution mains, storage facilities, pressure zones, and treatment plant connections." },
      { title: "Wastewater Collection", description: "Gravity sewers, force mains, pump stations, and collection system rehabilitation." },
      { title: "Stormwater Infrastructure", description: "Drainage systems, detention facilities, and green infrastructure solutions." },
      { title: "Telecommunications", description: "Conduit systems, fiber optic networks, and communications infrastructure." }
    ],
    technicalApproach: "Our utility design process emphasizes system reliability, operational efficiency, and construction feasibility. We use hydraulic modeling to optimize pipe sizing and system pressures, coordinate extensively with existing utility owners, and specify materials appropriate for site conditions and expected service life.",
    toolsAndMethods: [
      "WaterGEMS and SewerGEMS hydraulic modeling",
      "Subsurface utility engineering (SUE)",
      "Horizontal directional drilling (HDD)",
      "Pipe bursting and slip lining",
      "CCTV inspection systems",
      "GIS utility mapping and management"
    ],
    projectTypes: [
      "Municipal water main extensions",
      "Sewer system expansions",
      "Stormwater retrofits",
      "Utility corridor construction",
      "Service line replacements",
      "Pump station rehabilitation"
    ],
    caseExample: {
      title: "Downtown Utility Corridor Reconstruction",
      description: "Redspire led the comprehensive reconstruction of aging utility infrastructure beneath a busy commercial district. The project replaced 8,000 linear feet of water mains, 6,500 linear feet of sanitary sewers, and installed new telecommunications conduits—all while maintaining business access and minimizing traffic disruption through phased construction and trenchless methods."
    },
    whyMatters: "Utility infrastructure operates invisibly until it fails. Reliable water, sewer, and communications systems are fundamental to public health, economic activity, and quality of life. Redspire's utility engineering ensures these critical systems perform reliably for generations.",
    howDelivers: "We coordinate closely with utility owners, municipalities, and contractors to ensure seamless integration with existing systems. Our construction expertise enables us to specify practical installation methods and anticipate field challenges. We provide responsive support during construction to resolve issues and maintain project momentum.",
    images: [
      { src: "https://images.pexels.com/photos/1057858/pexels-photo-1057858.jpeg?w=800", alt: "Underground utility installation" },
      { src: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800", alt: "Utility trench construction" }
    ]
  },
  "design-build": {
    id: "design-build",
    title: "Design-Build Solutions",
    shortDescription: "Integrated design and construction services that streamline project delivery and reduce timelines.",
    icon: "PenTool",
    heroImage: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80",
    seo: {
      title: "Design-Build Civil Engineering Services | Redspire CT",
      description: "Integrated design-build delivery for civil infrastructure. Single-source responsibility, faster schedules, and cost certainty for your project.",
      keywords: ["design-build", "integrated delivery", "civil construction", "turnkey solutions"]
    },
    overview: "Redspire's design-build services offer owners single-source responsibility for both design and construction, eliminating the traditional barriers between engineering and field work. This integrated approach accelerates schedules, improves cost certainty, and enables real-time optimization throughout the project lifecycle.",
    whatIncludes: [
      "Conceptual design and estimating",
      "Detailed engineering design",
      "Permitting and regulatory approvals",
      "Procurement and subcontracting",
      "Construction execution",
      "Quality assurance and testing",
      "Commissioning and startup",
      "Warranty and maintenance support"
    ],
    coreCapabilities: [
      { title: "Fast-Track Delivery", description: "Overlapping design and construction phases to compress overall project schedules." },
      { title: "Cost Certainty", description: "Guaranteed maximum price contracts that provide budget security for owners." },
      { title: "Value Engineering", description: "Continuous optimization of design and construction methods to maximize project value." },
      { title: "Single Accountability", description: "One point of contact for all project matters, eliminating finger-pointing between parties." }
    ],
    technicalApproach: "Our design-build approach brings construction expertise into the design process from day one. Field supervisors and estimators participate in design reviews, identifying cost and schedule optimization opportunities while designs are still flexible. This collaboration continues through construction, with designers available to resolve field issues in real time.",
    toolsAndMethods: [
      "Integrated project delivery (IPD) methods",
      "Target value design processes",
      "Pull planning and lean construction",
      "Building Information Modeling (BIM)",
      "Cost modeling and estimating tools",
      "Real-time project dashboards"
    ],
    projectTypes: [
      "Water and wastewater treatment facilities",
      "Pump stations and lift stations",
      "Highway and bridge projects",
      "Transit facilities",
      "Industrial infrastructure",
      "Emergency and fast-track projects"
    ],
    caseExample: {
      title: "Emergency Pump Station Replacement",
      description: "When a critical sewage pump station failed unexpectedly, Redspire mobilized a design-build team to deliver a replacement facility in just 120 days. Our integrated approach allowed construction to begin while final design details were being completed. The new station features redundant pumps, emergency generator backup, and remote monitoring—all delivered under an aggressive schedule that prevented environmental impacts."
    },
    whyMatters: "Traditional design-bid-build delivery creates inherent conflicts between designers and contractors. Design-build aligns incentives, encourages innovation, and enables the collaborative problem-solving that complex civil projects require.",
    howDelivers: "Redspire's design-build teams are led by project managers with both engineering and construction backgrounds. We establish collaborative project environments, use shared risk and reward structures, and maintain transparent communication with owners throughout the process. Our track record demonstrates the schedule and cost benefits of true integrated delivery.",
    images: [
      { src: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800", alt: "Design-build project planning" },
      { src: "https://images.unsplash.com/photo-1531834685032-c34bf0d84c77?w=800", alt: "Integrated construction site" }
    ]
  },
  "transportation-engineering": {
    id: "transportation-engineering",
    title: "Transportation Engineering",
    shortDescription: "Planning and design of roadways, intersections, traffic systems, and multimodal transportation networks.",
    icon: "Route",
    heroImage: "https://images.unsplash.com/photo-1536099629323-44806c1ea264?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80",
    seo: {
      title: "Transportation Engineering Services | Redspire Connecticut",
      description: "Complete transportation engineering including roadway design, traffic analysis, intersection improvements, and multimodal planning in Connecticut.",
      keywords: ["transportation engineering", "roadway design", "traffic engineering", "intersection design"]
    },
    overview: "Redspire's transportation engineering services address the full spectrum of mobility challenges, from local intersection improvements to regional corridor planning. Our engineers combine traffic analysis expertise with practical roadway design, delivering solutions that improve safety, reduce congestion, and support sustainable transportation choices.",
    whatIncludes: [
      "Traffic impact studies and analysis",
      "Roadway geometric design",
      "Intersection design and signalization",
      "Roundabout design",
      "Pedestrian and bicycle facilities",
      "Parking facility design",
      "Access management planning",
      "Transportation master planning"
    ],
    coreCapabilities: [
      { title: "Traffic Analysis", description: "Existing conditions studies, traffic forecasting, and impact assessments using industry-standard methods." },
      { title: "Roadway Design", description: "Complete geometric design for new roads and reconstruction projects, from local streets to arterials." },
      { title: "Intersection Improvements", description: "Signal optimization, turn lane additions, and roundabout design to improve capacity and safety." },
      { title: "Multimodal Planning", description: "Integration of pedestrian, bicycle, transit, and vehicular modes in complete street designs." }
    ],
    technicalApproach: "Our transportation engineering begins with understanding how people and goods move through an area. We collect and analyze traffic data, model future conditions, and develop alternatives that balance capacity, safety, and community values. Designs are refined through iterative analysis until optimal solutions emerge.",
    toolsAndMethods: [
      "Synchro/SimTraffic for intersection analysis",
      "VISSIM for microsimulation modeling",
      "AutoCAD Civil 3D for roadway design",
      "Highway Capacity Manual methodologies",
      "AASHTO design standards",
      "Safety analysis and crash reduction factors"
    ],
    projectTypes: [
      "Intersection capacity improvements",
      "Corridor studies and improvements",
      "Roundabout design and construction",
      "Complete streets projects",
      "Parking structure and lot design",
      "Traffic signal design and optimization"
    ],
    caseExample: {
      title: "Commercial Corridor Redesign",
      description: "Redspire redesigned a congested 3-mile commercial corridor to improve traffic flow while enhancing pedestrian safety and access to local businesses. The project converted two signalized intersections to roundabouts, added dedicated turn lanes at three locations, and installed new sidewalks and crosswalks throughout. Post-construction analysis showed 28% reduction in travel times and 45% reduction in crashes."
    },
    whyMatters: "Transportation networks directly impact quality of life, economic vitality, and environmental sustainability. Thoughtful transportation engineering reduces congestion, improves safety, and enables communities to grow while maintaining mobility for all users.",
    howDelivers: "Our transportation engineers work closely with communities, understanding local priorities and concerns. We present alternatives clearly, explaining trade-offs and recommendations in accessible terms. Our designs meet or exceed applicable standards while incorporating innovative solutions appropriate for each unique context.",
    images: [
      { src: "https://images.unsplash.com/photo-1536099629323-44806c1ea264?w=800", alt: "Highway interchange design" },
      { src: "https://images.unsplash.com/photo-1519043916581-33ecfdba3b1c?w=800", alt: "Modern intersection design" }
    ]
  },
  "water-resources": {
    id: "water-resources",
    title: "Water Resources Engineering",
    shortDescription: "Stormwater management, flood control, watershed planning, and water treatment facility design.",
    icon: "Droplets",
    heroImage: "https://images.pexels.com/photos/434659/pexels-photo-434659.jpeg?w=1920",
    seo: {
      title: "Water Resources Engineering | Redspire Civil Connecticut",
      description: "Expert water resources engineering including stormwater management, flood control, watershed planning, and sustainable drainage solutions.",
      keywords: ["water resources engineering", "stormwater management", "flood control", "watershed planning"]
    },
    overview: "Redspire's water resources engineers address the complex challenges of managing water in developed environments. From stormwater quality treatment to regional flood control, we design systems that protect communities while meeting regulatory requirements and environmental objectives.",
    whatIncludes: [
      "Stormwater management design",
      "Flood control and mitigation",
      "Watershed planning and modeling",
      "Stream restoration and stabilization",
      "Detention and retention facilities",
      "Green infrastructure design",
      "Drainage system design",
      "Water quality treatment systems"
    ],
    coreCapabilities: [
      { title: "Stormwater Management", description: "Comprehensive solutions for runoff quantity and quality control meeting local and state requirements." },
      { title: "Flood Mitigation", description: "Structural and non-structural approaches to reducing flood risks in vulnerable areas." },
      { title: "Watershed Planning", description: "Basin-wide analysis and planning for sustainable water resource management." },
      { title: "Green Infrastructure", description: "Rain gardens, bioswales, permeable pavements, and other sustainable drainage approaches." }
    ],
    technicalApproach: "Our water resources engineering integrates hydrology, hydraulics, and environmental science to develop solutions that work with natural systems rather than against them. We use calibrated models to predict system performance under various conditions, then design facilities with appropriate safety factors and maintenance accessibility.",
    toolsAndMethods: [
      "HEC-HMS and HEC-RAS modeling",
      "SWMM for urban drainage analysis",
      "GIS-based watershed delineation",
      "Flood frequency analysis",
      "Water quality modeling",
      "Dam breach analysis"
    ],
    projectTypes: [
      "Regional detention facilities",
      "Stream channel improvements",
      "Flood plain management",
      "Low-impact development projects",
      "Dam safety improvements",
      "Coastal resilience projects"
    ],
    caseExample: {
      title: "Regional Flood Resilience Program",
      description: "Redspire led the engineering for a comprehensive flood mitigation program protecting a 12-square-mile watershed. The program included three regional detention basins, 4 miles of channel improvements, and flood-proofing measures for critical facilities. Since completion, the protected area has experienced no significant flood damage despite multiple major storm events."
    },
    whyMatters: "Water shapes communities in profound ways—providing essential resources while posing flood and erosion risks. Effective water resources engineering balances these dynamics, protecting developed areas while maintaining healthy watersheds and aquatic ecosystems.",
    howDelivers: "Our water resources team combines modeling expertise with practical field experience. We design facilities that perform as intended, can be maintained efficiently, and adapt to changing conditions over time. Regulatory permitting is integrated into our design process, avoiding surprises and delays.",
    images: [
      { src: "https://images.pexels.com/photos/434659/pexels-photo-434659.jpeg?w=800", alt: "Water treatment facility" },
      { src: "https://images.pexels.com/photos/224924/pexels-photo-224924.jpeg?w=800", alt: "Stormwater detention basin" }
    ]
  },
  "land-development": {
    id: "land-development",
    title: "Land Development & Site Engineering",
    shortDescription: "Site planning, grading, drainage design, and permitting for commercial and residential developments.",
    icon: "MapPin",
    heroImage: "https://images.unsplash.com/photo-1580810734915-93a368ed2073?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80",
    seo: {
      title: "Land Development & Site Engineering | Redspire CT",
      description: "Complete site engineering services for commercial and residential developments. Grading, drainage, utilities, and permitting in Connecticut.",
      keywords: ["land development", "site engineering", "site planning", "grading design"]
    },
    overview: "Redspire transforms raw land into functional development sites through comprehensive site engineering services. From initial feasibility through construction, we handle grading, drainage, utilities, and permitting—creating sites that are efficient to build and operate while meeting all regulatory requirements.",
    whatIncludes: [
      "Site feasibility analysis",
      "Conceptual site planning",
      "Grading and earthwork design",
      "Site drainage systems",
      "Utility layout and design",
      "Erosion and sediment control",
      "Permitting and approvals",
      "Construction administration"
    ],
    coreCapabilities: [
      { title: "Site Planning", description: "Optimal site layouts balancing development program, site constraints, and regulatory requirements." },
      { title: "Grading Design", description: "Earthwork optimization for construction economy while meeting drainage and accessibility needs." },
      { title: "Utility Coordination", description: "Integration of water, sewer, electric, gas, and telecommunications with site layouts." },
      { title: "Permitting Support", description: "Navigation of local, state, and federal approval processes for site development." }
    ],
    technicalApproach: "We approach site engineering as an optimization problem—balancing earthwork quantities, drainage requirements, utility service needs, and development objectives. Our iterative design process explores alternatives, quantifies trade-offs, and arrives at solutions that maximize site value while minimizing development costs and risks.",
    toolsAndMethods: [
      "AutoCAD Civil 3D for site design",
      "Cut/fill optimization software",
      "Stormwater modeling tools",
      "GIS for site analysis",
      "3D visualization and rendering",
      "Cost estimating databases"
    ],
    projectTypes: [
      "Commercial retail centers",
      "Industrial parks and warehouses",
      "Residential subdivisions",
      "Mixed-use developments",
      "Institutional campuses",
      "Recreational facilities"
    ],
    caseExample: {
      title: "200-Acre Industrial Park Development",
      description: "Redspire provided complete site engineering for a major industrial park development, transforming former agricultural land into shovel-ready industrial sites. Our design balanced 2 million cubic yards of earthwork, designed 15,000 linear feet of roadway, and extended water and sewer service throughout the property. The phased development approach allowed early sites to come online while later phases completed."
    },
    whyMatters: "Site engineering transforms land potential into buildable reality. Good site design optimizes development value, minimizes construction costs, and creates functional properties that serve their intended purposes efficiently for decades.",
    howDelivers: "Our site engineers understand both engineering requirements and development economics. We work closely with architects, developers, and contractors to create sites that meet everyone's objectives. Our permitting experience streamlines approvals, while our construction background ensures designs that build efficiently.",
    images: [
      { src: "https://images.unsplash.com/photo-1580810734915-93a368ed2073?w=800", alt: "Site grading and development" },
      { src: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800", alt: "Land development construction" }
    ]
  },
  "materials-testing": {
    id: "materials-testing",
    title: "Construction Materials Testing & QA",
    shortDescription: "Comprehensive testing and quality assurance services for concrete, soils, asphalt, and structural materials.",
    icon: "TestTube",
    heroImage: "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80",
    seo: {
      title: "Construction Materials Testing & QA | Redspire Engineering",
      description: "Accredited materials testing laboratory and field inspection services. Concrete, soil, asphalt, and structural testing in Connecticut.",
      keywords: ["materials testing", "quality assurance", "concrete testing", "soil testing"]
    },
    overview: "Redspire's materials testing services provide the quality assurance foundation for successful construction projects. Our accredited laboratories and certified technicians verify that materials meet specifications, providing the documentation and confidence that projects are built to last.",
    whatIncludes: [
      "Concrete testing and inspection",
      "Soil compaction testing",
      "Asphalt testing and inspection",
      "Structural steel inspection",
      "Aggregate testing",
      "Masonry testing",
      "Welding inspection",
      "Special inspections"
    ],
    coreCapabilities: [
      { title: "Laboratory Testing", description: "Accredited facilities for concrete, soil, aggregate, and asphalt testing with rapid turnaround." },
      { title: "Field Inspection", description: "Certified technicians performing on-site testing and inspection during construction." },
      { title: "Special Inspections", description: "Code-required inspections for structural steel, concrete, masonry, and other critical elements." },
      { title: "Quality Programs", description: "Development and implementation of project-specific quality assurance programs." }
    ],
    technicalApproach: "Our quality assurance programs are designed to catch problems early, when corrections are simple and inexpensive. We work with contractors to understand construction methods and schedules, then position inspectors and testing at critical points. Results are reported promptly, enabling immediate response to any issues.",
    toolsAndMethods: [
      "Nuclear density gauges for compaction",
      "Concrete compression testing machines",
      "Aggregate gradation equipment",
      "Marshall asphalt testing apparatus",
      "Ultrasonic testing equipment",
      "Digital reporting systems"
    ],
    projectTypes: [
      "Building construction",
      "Highway and bridge projects",
      "Site development",
      "Industrial facilities",
      "Water and wastewater structures",
      "Parking structures"
    ],
    caseExample: {
      title: "High-Rise Foundation Quality Program",
      description: "Redspire provided comprehensive materials testing for a 40-story building foundation involving 180 drilled shafts and 15,000 cubic yards of high-strength concrete. Our team performed continuous inspection during shaft installation, verified reinforcing steel placement, and tested every concrete placement. The quality program documented full specification compliance, providing the foundation for a successful project."
    },
    whyMatters: "Construction quality cannot be inspected into a project after the fact—it must be built in through proper materials and methods. Professional testing and inspection provides verification that specifications are met, protecting owners' investments and ensuring public safety.",
    howDelivers: "Our materials testing team integrates seamlessly with construction operations. We understand contractor schedules and workflow, positioning our services to provide timely results without delaying work. Our certified technicians are experienced professionals who understand both testing protocols and construction realities.",
    images: [
      { src: "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800", alt: "Laboratory materials testing" },
      { src: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800", alt: "Field testing equipment" }
    ]
  },
  "digital-twin": {
    id: "digital-twin",
    title: "3D Modelling & Digital Twin Engineering",
    shortDescription: "Advanced BIM services and digital twin technology for enhanced project visualization and lifecycle management.",
    icon: "Box",
    heroImage: "https://images.unsplash.com/photo-1485083269755-a7b559a4fe5e?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80",
    seo: {
      title: "3D Modelling & Digital Twin Services | Redspire Engineering",
      description: "Advanced BIM and digital twin engineering for infrastructure. 3D modeling, visualization, and lifecycle asset management solutions.",
      keywords: ["digital twin", "BIM", "3D modeling", "infrastructure visualization"]
    },
    overview: "Redspire's digital engineering services transform how infrastructure is designed, built, and operated. Our 3D modeling and digital twin capabilities enable better coordination during design, improved construction efficiency, and enhanced asset management throughout the infrastructure lifecycle.",
    whatIncludes: [
      "3D infrastructure modeling",
      "BIM coordination and clash detection",
      "Construction sequencing visualization",
      "Digital twin development",
      "Asset information modeling",
      "Reality capture and scanning",
      "Virtual and augmented reality",
      "Lifecycle data management"
    ],
    coreCapabilities: [
      { title: "BIM for Infrastructure", description: "Comprehensive 3D modeling for roads, bridges, utilities, and facilities with full attribute data." },
      { title: "Digital Twin Creation", description: "Living digital representations of physical infrastructure that update with real-world conditions." },
      { title: "Visualization Services", description: "Renderings, animations, and interactive models for stakeholder communication and decision-making." },
      { title: "Asset Management", description: "Integration of design data with operations and maintenance systems for lifecycle management." }
    ],
    technicalApproach: "We build digital models that serve multiple purposes throughout the project lifecycle. During design, models enable coordination and visualization. During construction, they guide field work and track progress. After construction, digital twins become the foundation for operations and maintenance, continuously updated with condition data.",
    toolsAndMethods: [
      "Autodesk Civil 3D and InfraWorks",
      "Bentley OpenRoads and OpenBridge",
      "Navisworks for coordination",
      "LiDAR and photogrammetry",
      "IoT sensor integration",
      "Cloud-based collaboration platforms"
    ],
    projectTypes: [
      "Complex highway interchanges",
      "Major bridge structures",
      "Transit facilities",
      "Water treatment plants",
      "Utility corridors",
      "Municipal asset inventories"
    ],
    caseExample: {
      title: "Regional Transit System Digital Twin",
      description: "Redspire developed a comprehensive digital twin for a 25-mile transit corridor, integrating design models, as-built documentation, and real-time operations data. The digital twin enables maintenance staff to visualize buried utilities before excavation, track asset conditions, and plan capital improvements. The system has reduced maintenance response times by 35% and improved capital planning accuracy."
    },
    whyMatters: "Digital technology is transforming civil engineering, enabling better designs, more efficient construction, and smarter operations. Organizations that embrace digital tools gain competitive advantages through improved quality, reduced costs, and enhanced decision-making capabilities.",
    howDelivers: "Our digital engineering team combines software expertise with deep civil engineering knowledge. We don't just build models—we build models that solve problems and deliver value. Our solutions are practical and implementable, designed for real-world use by design teams, construction crews, and operations staff.",
    images: [
      { src: "https://images.unsplash.com/photo-1485083269755-a7b559a4fe5e?w=800", alt: "3D infrastructure model" },
      { src: "https://images.unsplash.com/photo-1531834685032-c34bf0d84c77?w=800", alt: "Digital twin visualization" }
    ]
  }
};

export const services = Object.values(servicesData).map(s => ({
  id: s.id,
  title: s.title,
  description: s.shortDescription,
  icon: s.icon,
  href: `/services/${s.id}`
}));

export const projectsData = {
  "transit-corridor-upgrade": {
    id: "transit-corridor-upgrade",
    title: "Redspire Transit Corridor Upgrade",
    slug: "transit-corridor-upgrade",
    status: "In Progress",
    category: "Transportation",
    location: "Greater Hartford Region, CT",
    client: "Connecticut Department of Transportation",
    value: "Value undisclosed",
    duration: "2023 - 2027",
    heroImage: "https://images.unsplash.com/photo-1536099629323-44806c1ea264?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80",
    seo: {
      title: "Transit Corridor Upgrade Project | Redspire Engineering",
      description: "Comprehensive 12km transit corridor modernization featuring new stations, elevated tracks, and multimodal connections. Serving 200,000+ daily commuters in Connecticut.",
      keywords: ["transit corridor", "rail modernization", "Connecticut transit", "multimodal transportation"]
    },
    summary: "The Redspire Transit Corridor Upgrade represents one of the most significant transit infrastructure investments in Connecticut's recent history. This comprehensive modernization project transforms 12 kilometers of aging urban transit infrastructure into a modern, efficient, and accessible system serving over 200,000 daily commuters. The project encompasses six new stations, elevated track sections through congested areas, integrated multimodal connections, and state-of-the-art passenger information systems.",
    scopeOfWork: [
      "Demolition and removal of existing infrastructure along 12km corridor",
      "Construction of 6 new accessible transit stations with modern amenities",
      "Installation of 4.5km of elevated track through urban centers",
      "Integration of bus rapid transit connections at 3 stations",
      "Implementation of real-time passenger information systems",
      "Construction of 2,400 parking spaces across 4 park-and-ride facilities",
      "Pedestrian and bicycle access improvements throughout corridor",
      "Signal priority systems at 28 intersections"
    ],
    technicalApproach: "Our engineering approach prioritizes minimizing disruption to existing transit operations while delivering transformative infrastructure improvements. We employ phased construction sequencing that maintains continuous service on parallel routes, with night and weekend work windows for critical tie-in activities. Advanced BIM coordination ensures clash-free design across structural, mechanical, electrical, and signal systems. Real-time monitoring during construction validates structural performance and identifies any settlement or movement requiring mitigation.",
    challenges: [
      {
        challenge: "Maintaining Transit Operations",
        solution: "Developed comprehensive traffic management plan with parallel bus bridges and weekend closures for major construction phases. Coordinated with transit authority on 6-month advance public communication campaign."
      },
      {
        challenge: "Elevated Structure in Dense Urban Area",
        solution: "Utilized precast concrete segments fabricated off-site to minimize on-site construction time. Employed specialized launch gantry to erect segments during overnight windows with minimal traffic impact."
      },
      {
        challenge: "Underground Utility Conflicts",
        solution: "Conducted extensive subsurface utility engineering (SUE) investigation to map all utilities. Coordinated 23 utility relocations with 8 different utility owners over 18-month advance timeline."
      },
      {
        challenge: "Historic District Sensitivity",
        solution: "Designed station architecture to complement historic building facades. Used noise barriers and vibration isolation measures to protect adjacent historic structures during construction."
      }
    ],
    timeline: [
      { phase: "Planning & Design", period: "2021 - 2023", description: "Environmental review, preliminary engineering, final design, and permitting." },
      { phase: "Phase 1 Construction", period: "2023 - 2024", description: "Utility relocations, station foundation work, and elevated structure in western corridor." },
      { phase: "Phase 2 Construction", period: "2024 - 2025", description: "Central station construction, track installation, and systems integration." },
      { phase: "Phase 3 Construction", period: "2025 - 2026", description: "Eastern corridor completion, park-and-ride facilities, and access improvements." },
      { phase: "Testing & Commissioning", period: "2026 - 2027", description: "System testing, operator training, and phased service introduction." }
    ],
    materials: [
      "High-performance concrete for elevated structures (8,000 psi)",
      "Weathering steel for architectural elements",
      "Precast concrete segments for guideway",
      "Continuous welded rail (CWR) for smooth ride quality",
      "Direct fixation track fasteners for noise reduction",
      "Glass and aluminum curtain wall systems for stations"
    ],
    sustainability: [
      "LEED Gold certification targeted for all station buildings",
      "Solar panel arrays on station roofs generating 40% of station power",
      "Rainwater harvesting systems for landscape irrigation",
      "Native landscaping requiring minimal irrigation",
      "LED lighting throughout with smart controls",
      "Electric vehicle charging stations at park-and-ride facilities"
    ],
    communityImpact: "Upon completion, the Transit Corridor Upgrade will reduce average commute times by 35%, eliminate an estimated 15,000 daily vehicle trips, and provide reliable transit access to underserved neighborhoods. The project creates over 2,000 construction jobs and will support long-term economic development along the corridor. Enhanced accessibility features ensure the system serves all community members, including those with mobility challenges.",
    images: [
      { src: "https://images.unsplash.com/photo-1536099629323-44806c1ea264?w=800", alt: "Transit corridor construction overview" },
      { src: "https://images.unsplash.com/photo-1519043916581-33ecfdba3b1c?w=800", alt: "Modern transit station design rendering" },
      { src: "https://images.unsplash.com/photo-1527335988388-b40ee248d80c?w=800", alt: "Elevated track section construction" },
      { src: "https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=800", alt: "Project team coordination meeting" }
    ]
  },
  "northwind-river-bridge": {
    id: "northwind-river-bridge",
    title: "Northwind River Bridge Replacement",
    slug: "northwind-river-bridge",
    status: "In Progress",
    category: "Structural",
    location: "Northwind River Crossing, CT",
    client: "Connecticut DOT / Federal Highway Administration",
    value: "Value undisclosed",
    duration: "2022 - 2026",
    heroImage: "https://images.unsplash.com/photo-1529926691761-20fb82067c71?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80",
    seo: {
      title: "Northwind River Bridge Replacement | Redspire Engineering",
      description: "850-meter cable-stayed bridge replacement with seismic resilience and dedicated pedestrian pathways. Major Connecticut infrastructure project.",
      keywords: ["bridge replacement", "cable-stayed bridge", "seismic design", "Connecticut infrastructure"]
    },
    summary: "The Northwind River Bridge Replacement project delivers a signature cable-stayed bridge replacing the aging 1960s-era structure that has served as a vital regional transportation link. The new 850-meter bridge features a distinctive single-pylon design rising 145 meters above the river, dual vehicular roadways accommodating 65,000 daily vehicles, and Connecticut's first dedicated pedestrian and bicycle pathway integrated into a major river crossing. Advanced seismic isolation systems ensure the structure's resilience against earthquake events.",
    scopeOfWork: [
      "Demolition of existing 4-lane bridge structure",
      "Construction of new 6-lane cable-stayed bridge (850m span)",
      "Installation of 145-meter single steel pylon",
      "Placement of 72 cable stays supporting bridge deck",
      "Construction of seismic isolation bearing systems",
      "Installation of dedicated 4-meter pedestrian/bicycle pathway",
      "Approach roadway reconstruction (2.5km total)",
      "Navigation channel improvements for maritime traffic"
    ],
    technicalApproach: "The bridge design employs a single-pylon cable-stayed configuration chosen for its structural efficiency, constructability, and iconic visual presence. The steel pylon transfers deck loads through 72 cables to deep foundations bearing on bedrock 40 meters below the riverbed. The composite steel-concrete deck minimizes self-weight while providing durability. Friction pendulum seismic isolation bearings at the pylon base allow controlled movement during seismic events while re-centering after ground motion ceases.",
    challenges: [
      {
        challenge: "Deep Water Foundation Construction",
        solution: "Employed twin steel cofferdams with tremie concrete seals to create dry work areas 35 meters below water surface. Continuous dewatering maintained dry conditions throughout foundation construction."
      },
      {
        challenge: "Navigation Channel Requirements",
        solution: "Coordinated construction schedule with Coast Guard and port authority to maintain 100-meter navigation channel throughout construction. Installed navigation aids and employed marine traffic coordinators during critical operations."
      },
      {
        challenge: "Wind Loading on Tall Pylon",
        solution: "Conducted wind tunnel testing of 1:100 scale model to optimize pylon aerodynamics. Installed tuned mass dampers within pylon to control wind-induced vibration during construction and service."
      },
      {
        challenge: "Maintaining Traffic During Construction",
        solution: "Constructed new bridge on alignment adjacent to existing structure, allowing full traffic flow until switchover. Phased approach roadway work during off-peak hours."
      }
    ],
    timeline: [
      { phase: "Design & Permitting", period: "2020 - 2022", description: "Final design, environmental clearance, and regulatory approvals." },
      { phase: "Foundation Construction", period: "2022 - 2023", description: "Cofferdam installation, pile driving, and foundation concrete." },
      { phase: "Pylon Erection", period: "2023 - 2024", description: "Steel pylon fabrication, erection, and cable anchorage installation." },
      { phase: "Deck Construction", period: "2024 - 2025", description: "Segmental deck construction and cable installation using balanced cantilever method." },
      { phase: "Completion", period: "2025 - 2026", description: "Deck finishing, approach connections, demolition of old bridge." }
    ],
    materials: [
      "High-strength structural steel (Grade 70 for pylon)",
      "Stay cables with parallel strand system (1860 MPa)",
      "High-performance concrete (10,000 psi for deck)",
      "Corrosion-resistant reinforcing steel",
      "Friction pendulum seismic isolation bearings",
      "Advanced polymer modified asphalt for deck surface"
    ],
    sustainability: [
      "Design for 150-year service life minimizing replacement needs",
      "LED lighting with smart controls reducing energy 60%",
      "Stormwater treatment before discharge to river",
      "Recycling of 85% of demolished bridge materials",
      "Native species restoration along approach roadways",
      "Electric vehicle charging infrastructure at adjacent rest area"
    ],
    communityImpact: "The new Northwind River Bridge transforms regional connectivity while creating an iconic landmark. The dedicated pedestrian and bicycle pathway opens new active transportation options connecting communities previously separated by the river. Enhanced capacity reduces congestion-related delays by 40%, improving freight movement and commuter travel times. The bridge design has become a source of community pride, featured in regional tourism promotion.",
    images: [
      { src: "https://images.unsplash.com/photo-1529926691761-20fb82067c71?w=800", alt: "Cable-stayed bridge main span" },
      { src: "https://images.unsplash.com/photo-1513828583688-c52646db42da?w=800", alt: "Bridge pylon under construction" },
      { src: "https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=800", alt: "River crossing at sunset" },
      { src: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800", alt: "Construction progress aerial view" }
    ]
  },
  "harborline-utilities": {
    id: "harborline-utilities",
    title: "Harborline Deep Utilities Expansion",
    slug: "harborline-utilities",
    status: "Completed",
    category: "Utilities",
    location: "Stamford Waterfront District, CT",
    client: "City of Stamford / Aquarion Water Company",
    value: "Value undisclosed",
    duration: "2020 - 2024",
    heroImage: "https://images.pexels.com/photos/1057858/pexels-photo-1057858.jpeg?w=1920",
    seo: {
      title: "Harborline Deep Utilities Expansion | Redspire Engineering",
      description: "Major underground utilities corridor expansion including water mains, storm sewers, and fiber optic conduits across Stamford's waterfront district.",
      keywords: ["utility construction", "water main installation", "underground infrastructure", "Stamford CT"]
    },
    summary: "The Harborline Deep Utilities Expansion delivered critical infrastructure upgrades to support the redevelopment of Stamford's waterfront district. This comprehensive underground project installed 8.5 kilometers of new water transmission mains, 6.2 kilometers of sanitary sewer, 7.8 kilometers of storm drainage, and telecommunications conduit throughout the corridor. The project employed extensive trenchless technology to minimize surface disruption in this active commercial and residential area.",
    scopeOfWork: [
      "Installation of 48-inch ductile iron water transmission main (3.2km)",
      "Installation of 24-inch distribution mains (5.3km)",
      "Gravity sanitary sewer installation (6.2km ranging 12-36 inch)",
      "Storm drainage system with treatment (7.8km)",
      "Telecommunications conduit bank (12-way, 8.5km)",
      "Three new water pump stations",
      "Two sanitary lift stations with emergency generators",
      "Surface restoration and streetscape improvements"
    ],
    technicalApproach: "The project maximized use of trenchless construction methods to minimize disruption in the active waterfront district. Microtunneling installed the deep water transmission main beneath major roadways without surface excavation. Horizontal directional drilling placed utilities beneath sensitive areas including waterfront parks and historic sites. Where open-cut was required, we employed steel trench shields and rapid backfill techniques to limit excavation duration. Real-time ground movement monitoring protected adjacent structures.",
    challenges: [
      {
        challenge: "High Groundwater Table",
        solution: "Installed dewatering well systems in advance of construction. Used slurry-supported excavations for deep structures. Specified water-tight joints and coatings for all below-grade infrastructure."
      },
      {
        challenge: "Contaminated Soils",
        solution: "Conducted pre-construction environmental sampling to characterize materials. Segregated contaminated soils for appropriate disposal. Obtained necessary environmental permits for handling and transport."
      },
      {
        challenge: "Active Commercial District",
        solution: "Developed detailed traffic control plans maintaining business access. Constructed during evening and weekend hours in most sensitive areas. Provided advance notification and coordination with business owners."
      },
      {
        challenge: "Existing Utility Conflicts",
        solution: "Performed comprehensive SUE investigation to Level A (potholing). Coordinated 45 utility relocations with 12 different owners. Used vacuum excavation for safe exposure of existing utilities."
      }
    ],
    timeline: [
      { phase: "Design & Permitting", period: "2019 - 2020", description: "Utility design, environmental assessment, and regulatory approvals." },
      { phase: "Phase 1 - Western Sector", period: "2020 - 2021", description: "Water main installation, pump station construction." },
      { phase: "Phase 2 - Central Sector", period: "2021 - 2022", description: "Sanitary sewer, storm drainage, and telecom conduit." },
      { phase: "Phase 3 - Eastern Sector", period: "2022 - 2023", description: "Final utility connections, lift stations, and system integration." },
      { phase: "Surface Restoration", period: "2023 - 2024", description: "Pavement restoration, streetscape improvements, final testing." }
    ],
    materials: [
      "Ductile iron pipe (cement-lined) for water mains",
      "PVC gravity sewer pipe (SDR 26)",
      "HDPE force main for lift station discharge",
      "Reinforced concrete pipe for storm drainage",
      "HDPE conduit for telecommunications",
      "Precast concrete structures for manholes and vaults"
    ],
    sustainability: [
      "Recycled aggregate base materials (40% recycled content)",
      "Low-energy pump station designs with VFD motors",
      "Bioretention facilities treating 85% of stormwater",
      "Trenchless methods reducing surface disturbance by 60%",
      "Reuse of excavated materials where quality permits",
      "Smart water meters enabling leak detection and conservation"
    ],
    communityImpact: "The Harborline utilities expansion enables development of 2.5 million square feet of new waterfront construction while upgrading service to existing customers. Water pressure improvements benefit 4,200 existing connections. New stormwater treatment systems protect harbor water quality, supporting recreational and ecological uses. The improved infrastructure positioned the waterfront district for sustainable growth while protecting public health and the environment.",
    images: [
      { src: "https://images.pexels.com/photos/1057858/pexels-photo-1057858.jpeg?w=800", alt: "Underground utility installation" },
      { src: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800", alt: "Pipe laying operation" },
      { src: "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800", alt: "Pump station interior" },
      { src: "https://images.pexels.com/photos/2219024/pexels-photo-2219024.jpeg?w=800", alt: "Completed streetscape restoration" }
    ]
  },
  "skycrest-foundations": {
    id: "skycrest-foundations",
    title: "Skycrest Commercial Tower Foundations",
    slug: "skycrest-foundations",
    status: "Completed",
    category: "Structural",
    location: "Downtown Hartford, CT",
    client: "Skycrest Development Partners",
    value: "Value undisclosed",
    duration: "2021 - 2023",
    heroImage: "https://images.unsplash.com/photo-1485083269755-a7b559a4fe5e?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80",
    seo: {
      title: "Skycrest Tower Foundation Engineering | Redspire Civil",
      description: "Deep foundation engineering for 52-story commercial tower with innovative pile design and groundwater management in challenging soil conditions.",
      keywords: ["deep foundations", "high-rise foundation", "pile design", "groundwater management"]
    },
    summary: "The Skycrest Commercial Tower foundation project delivered complex deep foundation systems supporting a 52-story mixed-use tower in downtown Hartford. The challenging site conditions—including variable fill materials, high groundwater, and proximity to historic structures—required innovative engineering solutions. Redspire designed and constructed a foundation system combining 186 drilled shafts, a 4-foot-thick mat foundation, and a comprehensive dewatering and waterproofing system enabling three levels of underground parking.",
    scopeOfWork: [
      "Geotechnical investigation and foundation engineering",
      "Installation of 186 drilled shafts (36-60 inch diameter)",
      "Construction of 4-foot-thick reinforced concrete mat foundation",
      "Excavation support system for 45-foot-deep basement",
      "Permanent dewatering system design and installation",
      "Below-grade waterproofing and drainage systems",
      "Foundation load testing program",
      "Settlement and groundwater monitoring"
    ],
    technicalApproach: "Our foundation design addressed the tower's 485,000-kip total load through an optimized combination of drilled shafts bearing on rock and a mat foundation distributing loads to competent glacial till. Finite element modeling analyzed soil-structure interaction and predicted settlements within acceptable limits. The excavation support system combined soldier pile and lagging with tiebacks to retain surrounding streets while allowing efficient basement construction. Real-time monitoring validated design assumptions throughout construction.",
    challenges: [
      {
        challenge: "Variable Subsurface Conditions",
        solution: "Conducted extensive geotechnical investigation with 35 borings. Designed foundation system adaptable to actual rock depths encountered. Performed load tests verifying capacity."
      },
      {
        challenge: "Adjacent Historic Structures",
        solution: "Installed pre-construction monitoring points on adjacent buildings. Used low-vibration drilling methods for shafts. Maintained continuous settlement monitoring throughout construction."
      },
      {
        challenge: "High Groundwater and Contamination",
        solution: "Designed permanent underdrain system maintaining dry basement. Treated all extracted groundwater before discharge. Installed robust waterproofing system with redundant protection."
      },
      {
        challenge: "Congested Urban Site",
        solution: "Developed detailed logistics plan for material delivery and spoils removal. Coordinated with city for lane closures during concrete pours. Employed night work for oversized equipment mobilization."
      }
    ],
    timeline: [
      { phase: "Geotechnical Investigation", period: "2020 - 2021", description: "Subsurface exploration, laboratory testing, and foundation design." },
      { phase: "Excavation Support", period: "2021", description: "Soldier pile installation, excavation, and tieback installation." },
      { phase: "Shaft Installation", period: "2021 - 2022", description: "Drilled shaft construction with real-time monitoring." },
      { phase: "Mat Foundation", period: "2022", description: "Mat reinforcing placement and mass concrete placement." },
      { phase: "Waterproofing & Completion", period: "2022 - 2023", description: "Below-grade waterproofing, dewatering system, and basement completion." }
    ],
    materials: [
      "High-strength concrete (12,000 psi for mat foundation)",
      "Grade 60 reinforcing steel (4.2 million pounds)",
      "Polymer drilling fluid for shaft construction",
      "Crystalline waterproofing admixture",
      "Bentonite-HDPE composite waterproofing",
      "PVC waterstops at all construction joints"
    ],
    sustainability: [
      "Supplementary cementitious materials reducing cement content 30%",
      "Recycled steel reinforcement (95% recycled content)",
      "Heat recovery from mass concrete curing",
      "Groundwater discharge to storm system reducing treatment needs",
      "Reuse of excavated rock as aggregate",
      "Foundation design enabling future building modifications"
    ],
    communityImpact: "The Skycrest Tower brings 1.2 million square feet of Class A office space and ground-floor retail to downtown Hartford, supporting the city's economic development goals. The project created 450 construction jobs during the 2-year foundation phase. The below-grade parking provides 400 spaces, reducing surface parking demand. The tower's completion anchors ongoing downtown revitalization efforts.",
    images: [
      { src: "https://images.unsplash.com/photo-1485083269755-a7b559a4fe5e?w=800", alt: "Tower construction with cranes" },
      { src: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800", alt: "Drilled shaft installation" },
      { src: "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800", alt: "Mat foundation reinforcing" },
      { src: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800", alt: "Completed tower exterior" }
    ]
  },
  "midland-wastewater": {
    id: "midland-wastewater",
    title: "Midland Wastewater Modernization",
    slug: "midland-wastewater",
    status: "Completed",
    category: "Water Resources",
    location: "Midland Region, CT",
    client: "Midland Regional Water Pollution Control Authority",
    value: "Value undisclosed",
    duration: "2019 - 2024",
    heroImage: "https://images.pexels.com/photos/434659/pexels-photo-434659.jpeg?w=1920",
    seo: {
      title: "Midland Wastewater Treatment Modernization | Redspire",
      description: "Complete renovation of regional wastewater treatment facility serving 150,000 residents. Advanced treatment and energy efficiency upgrades.",
      keywords: ["wastewater treatment", "water pollution control", "facility modernization", "environmental engineering"]
    },
    summary: "The Midland Wastewater Modernization project transformed a 1970s-era treatment facility into a state-of-the-art water reclamation plant serving 150,000 residents. The comprehensive upgrade replaced aging infrastructure, implemented advanced nutrient removal processes meeting stringent discharge requirements, and incorporated energy recovery systems reducing operating costs by 40%. The project was delivered while maintaining continuous treatment operations throughout the 5-year construction period.",
    scopeOfWork: [
      "New 24 MGD headworks facility with screening and grit removal",
      "Biological nutrient removal (BNR) process conversion",
      "Secondary clarifier rehabilitation (4 units)",
      "New UV disinfection system replacing chlorination",
      "Biosolids digestion and energy recovery systems",
      "Odor control improvements throughout facility",
      "New operations building and laboratory",
      "SCADA system upgrade for automated operations"
    ],
    technicalApproach: "Our design approach prioritized operational flexibility and resilience. The new BNR process uses a 5-stage Bardenpho configuration optimized for Connecticut's climate conditions, achieving nitrogen and phosphorus limits well below permit requirements. Redundancy in all critical systems ensures reliable treatment regardless of equipment outages. The new SCADA system enables operators to monitor and adjust processes in real-time, optimizing performance and energy use.",
    challenges: [
      {
        challenge: "Continuous Operations During Construction",
        solution: "Developed detailed construction sequencing maintaining minimum treatment capacity at all times. Constructed new facilities before demolishing existing ones. Used temporary bypass pumping for critical tie-ins."
      },
      {
        challenge: "Stringent Nutrient Limits",
        solution: "Designed BNR process with safety factors exceeding permit requirements. Included supplemental carbon addition capability for cold weather operation. Installed continuous nutrient monitoring for process control."
      },
      {
        challenge: "Aging Infrastructure",
        solution: "Conducted comprehensive condition assessment of all existing facilities. Prioritized rehabilitation of structures suitable for continued service. Designed new facilities for 50-year service life."
      },
      {
        challenge: "Odor Complaints from Neighbors",
        solution: "Installed covered facilities with odor control at all sources. Used biofilter technology for sustainable odor treatment. Established community liaison program addressing concerns promptly."
      }
    ],
    timeline: [
      { phase: "Planning & Design", period: "2018 - 2019", description: "Facility planning, design development, and permitting." },
      { phase: "Phase 1 Construction", period: "2019 - 2021", description: "Headworks, primary treatment, and biosolids facilities." },
      { phase: "Phase 2 Construction", period: "2021 - 2023", description: "BNR conversion, secondary clarifiers, and disinfection." },
      { phase: "Phase 3 Construction", period: "2023 - 2024", description: "Operations building, SCADA, and site improvements." },
      { phase: "Commissioning", period: "2024", description: "Process optimization and performance verification." }
    ],
    materials: [
      "Reinforced concrete structures (sulfate-resistant cement)",
      "Stainless steel equipment in corrosive areas",
      "FRP covers and odor control equipment",
      "High-efficiency aeration diffusers",
      "Advanced membrane UV disinfection system",
      "Cogeneration engines for biogas utilization"
    ],
    sustainability: [
      "Biogas cogeneration providing 60% of facility power",
      "Solar array on clarifier covers adding 15% renewable power",
      "Effluent reuse for non-potable facility needs",
      "Class A biosolids enabling beneficial land application",
      "Energy-efficient equipment reducing grid demand 40%",
      "Stormwater management treating facility runoff"
    ],
    communityImpact: "The modernized facility protects water quality in the Long Island Sound watershed while significantly reducing operating costs for ratepayers. Improved odor control has eliminated complaints from neighboring properties. The facility now serves as an educational resource, hosting student tours and public open houses demonstrating sustainable water management. Reliable treatment capacity enables continued regional growth.",
    images: [
      { src: "https://images.pexels.com/photos/434659/pexels-photo-434659.jpeg?w=800", alt: "Wastewater treatment facility overview" },
      { src: "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800", alt: "BNR process tanks" },
      { src: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800", alt: "UV disinfection system" },
      { src: "https://images.pexels.com/photos/224924/pexels-photo-224924.jpeg?w=800", alt: "Biosolids processing facility" }
    ]
  },
  "eastgate-transit-hub": {
    id: "eastgate-transit-hub",
    title: "Eastgate Rapid Transit Hub",
    slug: "eastgate-transit-hub",
    status: "In Progress",
    category: "Transportation",
    location: "Eastgate District, CT",
    client: "Greater Hartford Transit District",
    value: "Value undisclosed",
    duration: "2023 - 2027",
    heroImage: "https://images.unsplash.com/photo-1519043916581-33ecfdba3b1c?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80",
    seo: {
      title: "Eastgate Rapid Transit Hub Project | Redspire Engineering",
      description: "Multimodal transit hub integrating bus rapid transit, light rail, and pedestrian connections with sustainable design features.",
      keywords: ["transit hub", "multimodal transportation", "bus rapid transit", "sustainable design"]
    },
    summary: "The Eastgate Rapid Transit Hub creates a landmark multimodal transportation center connecting bus rapid transit, regional rail, and local bus services with pedestrian and bicycle networks. The facility features an architecturally distinctive canopy structure providing weather protection across a 3-acre site, real-time passenger information systems, and comprehensive accessibility features. Sustainable design elements target LEED Platinum certification.",
    scopeOfWork: [
      "Transit hub building (45,000 SF) with passenger amenities",
      "Signature canopy structure covering boarding platforms",
      "12 bus bays with level boarding platforms",
      "Regional rail platform with ADA access",
      "Bicycle parking and repair station (200 spaces)",
      "Kiss-and-ride and taxi staging areas",
      "Pedestrian plaza and public art installation",
      "Site utilities and stormwater management"
    ],
    technicalApproach: "The hub design optimizes passenger flow between modes while creating an inviting public space. Computational pedestrian modeling informed platform sizing and circulation paths. The signature canopy uses a cable-stayed steel structure with ETFE cushion cladding providing natural daylight while protecting from weather. Below-grade stormwater chambers capture runoff for irrigation reuse.",
    challenges: [
      {
        challenge: "Complex Multi-Agency Coordination",
        solution: "Established unified project management team with representatives from all transit agencies. Developed shared design standards and operational protocols. Created integrated schedule coordinating all stakeholder requirements."
      },
      {
        challenge: "Maintaining Transit Operations During Construction",
        solution: "Phased construction maintaining minimum service levels throughout. Constructed temporary facilities before demolishing existing stops. Coordinated service changes with extensive public communication."
      },
      {
        challenge: "Signature Architecture on Limited Budget",
        solution: "Used value engineering to optimize canopy design while maintaining visual impact. Selected durable, low-maintenance materials reducing lifecycle costs. Incorporated public art funding through percent-for-art program."
      }
    ],
    timeline: [
      { phase: "Design Development", period: "2022 - 2023", description: "Schematic design, stakeholder coordination, and permitting." },
      { phase: "Site Preparation", period: "2023 - 2024", description: "Demolition, utility relocation, and foundation construction." },
      { phase: "Structure Construction", period: "2024 - 2025", description: "Building construction and canopy erection." },
      { phase: "Systems & Finishes", period: "2025 - 2026", description: "MEP systems, finishes, and passenger amenities." },
      { phase: "Commissioning", period: "2026 - 2027", description: "Testing, operator training, and phased opening." }
    ],
    materials: [
      "Structural steel for canopy (weathering steel finish)",
      "ETFE cushion cladding for canopy cover",
      "Precast concrete for platforms and site elements",
      "Granite pavers for pedestrian plaza",
      "LED lighting throughout with smart controls",
      "Digital signage and wayfinding systems"
    ],
    sustainability: [
      "LEED Platinum certification targeted",
      "Net-zero energy through solar and efficiency",
      "Rainwater harvesting for irrigation and toilets",
      "Green roof on transit building",
      "Electric bus charging infrastructure",
      "Bicycle-friendly design promoting active transportation"
    ],
    communityImpact: "The Eastgate Transit Hub transforms regional mobility while creating a vibrant public space. The facility will serve 25,000 daily passengers upon opening, with capacity for future growth. Adjacent transit-oriented development is already underway, with 500 housing units and 150,000 SF of retail under construction. The hub anchors the Eastgate district's emergence as a walkable, transit-accessible neighborhood.",
    images: [
      { src: "https://images.unsplash.com/photo-1519043916581-33ecfdba3b1c?w=800", alt: "Transit hub design rendering" },
      { src: "https://images.unsplash.com/photo-1527335988388-b40ee248d80c?w=800", alt: "Canopy structure construction" },
      { src: "https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=800", alt: "Project team collaboration" },
      { src: "https://images.unsplash.com/photo-1536099629323-44806c1ea264?w=800", alt: "Site construction progress" }
    ]
  },
  "sundale-flood-resilience": {
    id: "sundale-flood-resilience",
    title: "Sundale Flood Resilience Upgrade",
    slug: "sundale-flood-resilience",
    status: "Completed",
    category: "Water Resources",
    location: "Sundale Watershed, CT",
    client: "Sundale Flood Control District",
    value: "Value undisclosed",
    duration: "2018 - 2023",
    heroImage: "https://images.pexels.com/photos/224924/pexels-photo-224924.jpeg?w=1920",
    seo: {
      title: "Sundale Flood Resilience Project | Redspire Civil Engineering",
      description: "Comprehensive flood mitigation including detention basins, channel improvements, and pump stations protecting 5,000-acre watershed.",
      keywords: ["flood control", "stormwater management", "detention basin", "flood mitigation"]
    },
    summary: "The Sundale Flood Resilience Upgrade delivers comprehensive flood protection for a 5,000-acre watershed that has experienced repeated flooding causing significant property damage. The project combines regional detention basins, channel improvements, pump stations, and property-level flood-proofing into an integrated system providing 100-year flood protection. Since completion, the protected area has experienced no significant flood damage despite multiple major storm events.",
    scopeOfWork: [
      "Three regional detention basins (combined 850 acre-feet storage)",
      "4.2 miles of channel improvements and bank stabilization",
      "Two stormwater pump stations (150,000 GPM combined capacity)",
      "Flood warning system with 45 monitoring stations",
      "Property-level flood-proofing for 125 structures",
      "Wetland creation and stream restoration",
      "Recreational trails on detention basin berms",
      "Public education and emergency preparedness program"
    ],
    technicalApproach: "Our flood mitigation strategy employed a systems approach analyzing the entire watershed to identify optimal intervention points. Hydrologic modeling using calibrated HEC-HMS simulated storm events and evaluated alternatives. The selected plan combines upstream detention reducing peak flows with downstream conveyance improvements and pump stations managing interior drainage. Real-time monitoring enables adaptive operation during storm events.",
    challenges: [
      {
        challenge: "Multiple Property Owners",
        solution: "Established voluntary buyout program for properties in detention basin footprint. Provided flood-proofing assistance to remaining structures. Created public-private partnership for ongoing maintenance."
      },
      {
        challenge: "Environmental Permitting",
        solution: "Designed stream restoration and wetland creation exceeding mitigation requirements. Incorporated natural channel design principles. Achieved Clean Water Act Section 404 permit approval through early agency coordination."
      },
      {
        challenge: "Existing Infrastructure Conflicts",
        solution: "Relocated utilities and roads where conflicts occurred. Designed detention basin outlets to maintain existing drainage patterns. Coordinated with railroad for crossing improvements."
      },
      {
        challenge: "Construction During Flood Season",
        solution: "Developed detailed flood response plan for construction areas. Installed temporary flood protection during vulnerable phases. Scheduled critical work during historically dry periods."
      }
    ],
    timeline: [
      { phase: "Planning & Design", period: "2016 - 2018", description: "Watershed study, alternative analysis, and design development." },
      { phase: "Property Acquisition", period: "2018 - 2019", description: "Easement acquisition and voluntary buyouts." },
      { phase: "Basin Construction", period: "2019 - 2021", description: "Regional detention basin construction." },
      { phase: "Channel & Pump Stations", period: "2021 - 2022", description: "Channel improvements and pump station construction." },
      { phase: "Restoration & Completion", period: "2022 - 2023", description: "Environmental restoration, trails, and system commissioning." }
    ],
    materials: [
      "Roller-compacted concrete for spillways",
      "Articulated concrete block for channel protection",
      "Geosynthetic clay liner for detention basins",
      "Submersible axial flow pumps",
      "Native plant materials for restoration",
      "Telemetry and SCADA equipment"
    ],
    sustainability: [
      "Natural channel design improving aquatic habitat",
      "Wetland creation exceeding regulatory requirements",
      "Native meadow establishment on detention berms",
      "Solar-powered monitoring stations",
      "Green infrastructure components reducing runoff",
      "Climate resilience incorporated in design assumptions"
    ],
    communityImpact: "The Sundale Flood Resilience Upgrade has eliminated flood damage that previously caused significant annual losses. Property values in the protected area have increased by an estimated 15%. The project created 12 miles of recreational trails now used by thousands of residents. Wetland creation provides wildlife habitat and educational opportunities. The flood warning system provides early notification enabling evacuation when needed.",
    images: [
      { src: "https://images.pexels.com/photos/224924/pexels-photo-224924.jpeg?w=800", alt: "Detention basin with spillway" },
      { src: "https://images.unsplash.com/photo-1446776709462-d6b525c57bd3?w=800", alt: "Channel improvement construction" },
      { src: "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800", alt: "Pump station installation" },
      { src: "https://images.pexels.com/photos/2219024/pexels-photo-2219024.jpeg?w=800", alt: "Restored wetland area" }
    ]
  },
  "parallax-industrial-park": {
    id: "parallax-industrial-park",
    title: "Parallax Industrial Park Phase II",
    slug: "parallax-industrial-park",
    status: "In Progress",
    category: "Land Development",
    location: "Eastern Connecticut",
    client: "Parallax Development Corporation",
    value: "Value undisclosed",
    duration: "2022 - 2026",
    heroImage: "https://images.unsplash.com/photo-1580810734915-93a368ed2073?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80",
    seo: {
      title: "Parallax Industrial Park Development | Redspire Engineering",
      description: "200-acre industrial park site development including roadways, utilities, stormwater systems, and rail connections.",
      keywords: ["industrial park development", "site engineering", "land development", "infrastructure"]
    },
    summary: "Parallax Industrial Park Phase II transforms 200 acres of former agricultural land into a modern industrial campus with direct rail access, fiber connectivity, and sustainable infrastructure. The development creates 12 pad-ready industrial sites ranging from 8 to 35 acres, supported by internal roadways, complete utilities, and regional stormwater management. The park targets advanced manufacturing, logistics, and data center tenants requiring reliable infrastructure and multimodal transportation access.",
    scopeOfWork: [
      "Mass grading of 200-acre site (2.1 million CY earthwork)",
      "Internal roadway network (4.5 miles)",
      "Water system with 2 MG elevated storage tank",
      "Sanitary sewer collection and pump station",
      "Regional stormwater system with 3 detention basins",
      "Rail siding and intermodal facility",
      "Electrical infrastructure (69kV substation)",
      "Fiber optic infrastructure to each lot"
    ],
    technicalApproach: "Our site design balanced earthwork to minimize import/export while creating optimal pad grades for industrial buildings. We designed roadways for heavy truck traffic with turning radii accommodating long combination vehicles. The stormwater system uses cascading detention providing water quality treatment while managing peak flows. Modular utility design enables phased construction matching market absorption.",
    challenges: [
      {
        challenge: "Significant Earthwork Balancing",
        solution: "Employed 3D machine control for precision grading. Optimized design to minimize haul distances. Installed temporary stockpile areas enabling efficient material management."
      },
      {
        challenge: "Wetland Impacts",
        solution: "Designed layout avoiding highest-quality wetlands. Created 15-acre mitigation wetland on-site. Obtained Section 404 permit through Army Corps coordination."
      },
      {
        challenge: "Rail Access Requirements",
        solution: "Coordinated with Class I railroad on siding design and construction. Designed intermodal facility for efficient container transfer. Obtained necessary railroad approvals and agreements."
      },
      {
        challenge: "Market Uncertainty",
        solution: "Designed flexible lot configurations adaptable to various tenants. Phased infrastructure matching development pace. Created marketing materials demonstrating site capabilities."
      }
    ],
    timeline: [
      { phase: "Planning & Permitting", period: "2021 - 2022", description: "Site design, environmental permitting, and utility agreements." },
      { phase: "Mass Grading", period: "2022 - 2023", description: "Site clearing, earthwork, and erosion control." },
      { phase: "Utilities & Roads", period: "2023 - 2024", description: "Water, sewer, drainage, and roadway construction." },
      { phase: "Rail & Power", period: "2024 - 2025", description: "Rail siding and electrical substation construction." },
      { phase: "Final Development", period: "2025 - 2026", description: "Pad completion, landscaping, and tenant improvements." }
    ],
    materials: [
      "Connecticut DOT standard roadway specifications",
      "Ductile iron water mains with restrained joints",
      "PVC gravity sewer with lined manholes",
      "HDPE stormwater detention pipes",
      "Geogrid stabilized subgrades",
      "LED roadway and site lighting"
    ],
    sustainability: [
      "Native meadow restoration on undeveloped areas",
      "Bioretention facilities at each lot",
      "Dark sky compliant lighting",
      "Electric vehicle charging infrastructure",
      "Tree preservation along site perimeter",
      "LEED ND principles incorporated in design"
    ],
    communityImpact: "At full build-out, Parallax Industrial Park Phase II will accommodate 4 million square feet of industrial development, creating an estimated 2,500 permanent jobs. The project generates significant property tax revenue supporting local schools and services. Rail access reduces truck traffic on regional roadways. Sustainable design features protect water quality in the adjacent Shetucket River watershed.",
    images: [
      { src: "https://images.unsplash.com/photo-1580810734915-93a368ed2073?w=800", alt: "Industrial park aerial view" },
      { src: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800", alt: "Mass grading operations" },
      { src: "https://images.pexels.com/photos/1117452/pexels-photo-1117452.jpeg?w=800", alt: "Rail siding construction" },
      { src: "https://images.pexels.com/photos/2219024/pexels-photo-2219024.jpeg?w=800", alt: "Completed roadway infrastructure" }
    ]
  },
  "highridge-emergency-route": {
    id: "highridge-emergency-route",
    title: "Highridge Emergency Route Realignment",
    slug: "highridge-emergency-route",
    status: "Completed",
    category: "Transportation",
    location: "Highridge Mountain Region, CT",
    client: "Connecticut Department of Transportation",
    value: "Value undisclosed",
    duration: "2019 - 2023",
    heroImage: "https://images.pexels.com/photos/53176/architecture-iron-steel-building-53176.jpeg?w=1920",
    seo: {
      title: "Highridge Emergency Route Realignment | Redspire Civil",
      description: "Critical highway realignment improving emergency access and reducing travel times through mountainous terrain with challenging geotechnical conditions.",
      keywords: ["highway realignment", "mountain road", "emergency access", "geotechnical engineering"]
    },
    summary: "The Highridge Emergency Route Realignment addressed critical safety and access deficiencies on a mountainous highway serving as the primary emergency route for isolated communities. The project realigned 6.2 miles of roadway, eliminating sharp curves and steep grades that impeded emergency vehicle access and contributed to frequent accidents. Innovative retaining wall solutions addressed challenging geotechnical conditions while minimizing environmental impacts.",
    scopeOfWork: [
      "Highway realignment (6.2 miles of 4-lane roadway)",
      "Rock excavation (450,000 CY)",
      "Mechanically stabilized earth walls (82,000 SF)",
      "Rock anchored walls (35,000 SF)",
      "Bridge replacement (3 structures)",
      "Rockfall protection systems",
      "Wildlife crossing structures",
      "Intersection improvements at 4 locations"
    ],
    technicalApproach: "Our alignment design balanced cut/fill quantities while improving horizontal and vertical geometry. Where rock cuts exceeded 80 feet, we employed controlled blasting with pre-split techniques limiting overbreak and vibration. Retaining walls combined MSE structures on fill slopes with rock anchored shotcrete where cut stability required support. Extensive geotechnical instrumentation validated design assumptions throughout construction.",
    challenges: [
      {
        challenge: "Variable Rock Conditions",
        solution: "Conducted detailed geologic mapping during construction. Adjusted wall designs based on actual conditions. Employed adaptable specifications accommodating variability."
      },
      {
        challenge: "Maintaining Emergency Access",
        solution: "Constructed parallel temporary roadway before closing existing route. Coordinated with emergency services on response plans. Maintained minimum two-lane access throughout project."
      },
      {
        challenge: "Environmental Sensitivity",
        solution: "Minimized clearing through optimized alignment. Installed wildlife crossing structures at documented migration corridors. Implemented comprehensive erosion control exceeding regulatory requirements."
      },
      {
        challenge: "Winter Construction Limitations",
        solution: "Extended construction season through temporary heating for concrete work. Stockpiled materials before winter closures. Adjusted schedule maximizing warm-weather production."
      }
    ],
    timeline: [
      { phase: "Design & Permitting", period: "2017 - 2019", description: "Alignment studies, environmental clearance, and detailed design." },
      { phase: "Clearing & Grading", period: "2019 - 2020", description: "Site preparation, rock excavation, and temporary road construction." },
      { phase: "Structures", period: "2020 - 2021", description: "Retaining walls, bridges, and rockfall protection." },
      { phase: "Roadway Construction", period: "2021 - 2022", description: "Pavement, drainage, and safety features." },
      { phase: "Completion", period: "2022 - 2023", description: "Finishing, landscaping, and decommissioning old route." }
    ],
    materials: [
      "Asphalt pavement with polymer-modified binder",
      "Mechanically stabilized earth with steel reinforcement",
      "Epoxy-coated rock anchors (50-ton capacity)",
      "Fiber-reinforced shotcrete",
      "Flexible rockfall barriers",
      "Weather-resistant bridge railings"
    ],
    sustainability: [
      "Balanced earthwork minimizing import/export",
      "Crushed rock from excavation used as aggregate",
      "Native seed mixes for revegetation",
      "LED lighting at intersections",
      "Pervious shoulders reducing concentrated runoff",
      "Dark sky compliant lighting design"
    ],
    communityImpact: "The Highridge Emergency Route Realignment has reduced average emergency response times by 12 minutes, a critical improvement for communities previously facing extended response times. Accident rates have dropped 65% since opening. Winter road closures due to accidents have been eliminated. Improved geometry enables efficient freight movement, reducing operating costs for local businesses. The project received a Connecticut DOT excellence award.",
    images: [
      { src: "https://images.pexels.com/photos/53176/architecture-iron-steel-building-53176.jpeg?w=800", alt: "Mountain highway construction" },
      { src: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800", alt: "Rock excavation operations" },
      { src: "https://images.unsplash.com/photo-1527335988388-b40ee248d80c?w=800", alt: "Retaining wall construction" },
      { src: "https://images.pexels.com/photos/2219024/pexels-photo-2219024.jpeg?w=800", alt: "Completed roadway section" }
    ]
  },
  "portview-seawall": {
    id: "portview-seawall",
    title: "Portview Seawall Reinforcement",
    slug: "portview-seawall",
    status: "In Progress",
    category: "Structural",
    location: "Portview Harbor, CT",
    client: "Portview Port Authority",
    value: "Value undisclosed",
    duration: "2023 - 2027",
    heroImage: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80",
    seo: {
      title: "Portview Seawall Reinforcement Project | Redspire Engineering",
      description: "Structural reinforcement and extension of 3km seawall protecting critical port infrastructure from storm surge and sea-level rise.",
      keywords: ["seawall construction", "coastal resilience", "port infrastructure", "storm surge protection"]
    },
    summary: "The Portview Seawall Reinforcement project strengthens and extends 3 kilometers of seawall protecting critical port infrastructure, industrial facilities, and residential areas from storm surge and sea-level rise. The project addresses structural deterioration in the existing 1950s-era seawall while extending protection to previously vulnerable areas. Design criteria incorporate projected sea-level rise through 2100, ensuring long-term resilience.",
    scopeOfWork: [
      "Structural rehabilitation of existing seawall (2.1km)",
      "New seawall construction (0.9km)",
      "Sheet pile installation (45,000 SF)",
      "Concrete cap and wave wall (3km)",
      "Scour protection and armor stone",
      "Drainage improvements and tide gates",
      "Public waterfront promenade",
      "Emergency access improvements"
    ],
    technicalApproach: "Our coastal engineering approach combined wave modeling, storm surge analysis, and structural evaluation to develop an integrated protection system. We employed physical model testing at a hydraulic laboratory to optimize wave wall geometry and armor stone sizing. The structural rehabilitation uses fiber-reinforced polymer (FRP) reinforcement and cathodic protection extending service life 50+ years. All designs incorporate NOAA intermediate sea-level rise projections.",
    challenges: [
      {
        challenge: "Working in Tidal Environment",
        solution: "Developed detailed construction sequencing around tide windows. Used specialized marine equipment for below-water work. Installed temporary cofferdams for dry construction where possible."
      },
      {
        challenge: "Maintaining Port Operations",
        solution: "Phased construction maintaining access to all berths. Coordinated work schedules with vessel traffic. Provided advance notice of temporary restrictions."
      },
      {
        challenge: "Deteriorated Existing Structure",
        solution: "Conducted comprehensive condition assessment including underwater inspection. Designed rehabilitation addressing actual conditions. Specified contingency measures for unexpected deterioration."
      },
      {
        challenge: "Sea-Level Rise Uncertainty",
        solution: "Designed for intermediate projection with provisions for future raising. Used adaptive management approach enabling modifications as projections evolve. Incorporated monitoring systems tracking conditions."
      }
    ],
    timeline: [
      { phase: "Assessment & Design", period: "2022 - 2023", description: "Condition assessment, coastal modeling, and design development." },
      { phase: "Phase 1 Construction", period: "2023 - 2024", description: "Sheet pile installation and northern sector rehabilitation." },
      { phase: "Phase 2 Construction", period: "2024 - 2025", description: "Central sector rehabilitation and wave wall construction." },
      { phase: "Phase 3 Construction", period: "2025 - 2026", description: "Southern extension and new seawall construction." },
      { phase: "Completion", period: "2026 - 2027", description: "Promenade construction, landscaping, and project closeout." }
    ],
    materials: [
      "AZ steel sheet piling (high-strength, coated)",
      "Marine-grade concrete (sulfate and chloride resistant)",
      "Fiber-reinforced polymer (FRP) reinforcement",
      "Granite armor stone (8-12 ton class)",
      "Cathodic protection systems",
      "Stainless steel hardware and connections"
    ],
    sustainability: [
      "100-year design life reducing replacement frequency",
      "Recycled steel sheet piling where feasible",
      "Habitat-friendly armor stone placement",
      "Native coastal plantings on promenade",
      "Solar-powered monitoring stations",
      "Climate-adaptive design enabling future modifications"
    ],
    communityImpact: "The Portview Seawall Reinforcement protects critical port infrastructure, industrial assets, and nearby residential properties. The project preserves 3,500 port-related jobs while enabling future expansion. The new waterfront promenade creates 1.5 miles of public access previously unavailable. Enhanced storm surge protection reduces flood insurance costs for protected properties.",
    images: [
      { src: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=800", alt: "Seawall construction overview" },
      { src: "https://images.unsplash.com/photo-1513828583688-c52646db42da?w=800", alt: "Sheet pile installation" },
      { src: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800", alt: "Armor stone placement" },
      { src: "https://images.pexels.com/photos/2219024/pexels-photo-2219024.jpeg?w=800", alt: "Completed seawall section" }
    ]
  }
};

export const projects = Object.values(projectsData).map(p => ({
  id: p.id,
  title: p.title,
  description: p.summary.substring(0, 200) + '...',
  status: p.status,
  category: p.category,
  image: p.heroImage,
  href: `/projects/${p.slug}`
}));

export const team = [
  {
    id: 1,
    name: "Ruben Wargner",
    title: "Founder & Chief Strategy Officer",
    bio: "Veteran civil engineer from the Czech Republic with over three decades of experience in European infrastructure development. Ruben founded Redspire after leading major highway, bridge, and transit upgrades across Central Europe. He oversees long-term vision, engineering culture, and innovation strategy.",
    image: "/founder-silhouette.svg",
    imageAlt: "Founder Placeholder Image",
    isFounder: true,
    isPlaceholder: true
  },
  {
    id: 2,
    name: "Alden Cross",
    title: "Chief Executive Officer",
    bio: "Infrastructure leader with extensive experience in complex multi-phase civil programs. Guides corporate growth, strategic partnerships, and day-to-day executive operations.",
    image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=400&fit=crop&crop=top&facepad=3"
  },
  {
    id: 3,
    name: "Maya Lorne",
    title: "Chief Operating Officer",
    bio: "Specializes in construction operations, field delivery, and integrated project management. Ensures consistent execution across all Redspire initiatives.",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop&crop=top&facepad=2.5"
  },
  {
    id: 4,
    name: "Jonas Hale, P.Eng.",
    title: "Director of Engineering",
    bio: "Expert in structural and transportation engineering systems. Leads technical standards, quality assurance, and engineering innovation.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=top&facepad=2.5"
  },
  {
    id: 5,
    name: "Elena Farrow",
    title: "Director of Safety & Compliance",
    bio: "Oversees safety programs, regulatory alignment, and workforce protection. Champions zero-compromise incident prevention.",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop&crop=top&facepad=2.5"
  },
  {
    id: 6,
    name: "Priya Sandal",
    title: "Director of People & Talent",
    bio: "Leads recruitment, culture-building, and personnel development. Drives organizational growth and advancement opportunities.",
    image: "https://images.unsplash.com/photo-1598550874175-4d0ef436c909?w=400&h=400&fit=crop&crop=top&facepad=2.5"
  }
];

export const coreValues = [
  { title: "Integrity", description: "We build trust through honest communication and ethical practices in every interaction." },
  { title: "Safety First", description: "Zero compromise on safety. Every decision starts with protecting our people and communities." },
  { title: "Engineering Excellence", description: "Technical precision and quality craftsmanship define every project we deliver." },
  { title: "Innovation", description: "We embrace new technologies and methods to solve complex engineering challenges." },
  { title: "Community Impact", description: "Our work strengthens the communities where we live and build." },
  { title: "Collaboration", description: "Partnership and teamwork drive superior outcomes for clients and stakeholders." }
];

export const safetyProgram = [
  "Mandatory daily briefings and job hazard analyses",
  "Rigorous PPE and equipment standards",
  "Site-specific safety plans for every project",
  "Continuous training and certification",
  "Transparent reporting and corrective-action framework",
  "Zero-compromise approach to incident prevention"
];

export const news = [
  {
    id: 1,
    title: "Redspire Awarded Contract for Eastgate Transit Hub",
    excerpt: "This landmark project will transform regional connectivity and serve as a model for sustainable transit infrastructure.",
    date: "2025-07-15",
    category: "Projects",
    image: "https://images.unsplash.com/photo-1519043916581-33ecfdba3b1c?w=800&q=80"
  },
  {
    id: 2,
    title: "Safety Milestone: 2 Million Hours Without Lost-Time Incident",
    excerpt: "Our commitment to Safety First continues to deliver industry-leading performance across all project sites.",
    date: "2025-06-28",
    category: "Safety",
    image: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=800&q=80"
  },
  {
    id: 3,
    title: "Northwind Bridge Project Reaches Major Construction Milestone",
    excerpt: "The cable-stayed bridge deck connection marks a pivotal moment in this landmark infrastructure project.",
    date: "2025-06-10",
    category: "Projects",
    image: "https://images.unsplash.com/photo-1529926691761-20fb82067c71?w=800&q=80"
  },
  {
    id: 4,
    title: "Redspire Expands Digital Twin Capabilities",
    excerpt: "New technology partnership enhances our 3D modeling and infrastructure lifecycle management services.",
    date: "2025-05-22",
    category: "Innovation",
    image: "https://images.unsplash.com/photo-1485083269755-a7b559a4fe5e?w=800&q=80"
  },
  {
    id: 5,
    title: "Community Partnership: Youth Engineering Program Launch",
    excerpt: "Redspire sponsors hands-on STEM education initiative reaching 500 students in underserved communities.",
    date: "2025-05-08",
    category: "Community",
    image: "https://images.unsplash.com/photo-1580810734915-93a368ed2073?w=800&q=80"
  },
  {
    id: 6,
    title: "Q1 2025: Strong Project Delivery Across All Sectors",
    excerpt: "First quarter results demonstrate continued growth in infrastructure development and design-build services.",
    date: "2025-04-15",
    category: "Corporate",
    image: "https://images.unsplash.com/photo-1536895058696-a69b1c7ba34f?w=800&q=80"
  }
];

export const careers = [
  {
    id: 'senior-civil-engineer',
    title: "Senior Civil Engineer",
    location: "Stamford, CT",
    type: "Full-time",
    department: "Engineering",
    postedDate: "2025-08-01",
    summary: "Lead multi-disciplinary transportation and water projects across Connecticut while mentoring junior engineers.",
    description: "The Senior Civil Engineer leads planning and detailed design for complex public infrastructure programs. You will coordinate roadway, drainage, and structural elements, provide QA/QC, and represent Redspire in client and permitting meetings.",
    responsibilities: [
      "Lead multi-discipline design packages from concept through IFC",
      "Oversee production of plans, specifications, and cost estimates",
      "Coordinate with agencies on permits and technical reviews",
      "Mentor junior engineers and provide sealed deliverables"
    ],
    qualifications: [
      "B.S. in Civil Engineering, P.E. license in CT (or ability to obtain)",
      "8+ years delivering transportation or municipal infrastructure projects",
      "Proficiency with Civil 3D and drainage modeling tools",
      "Strong communication and client-facing skills"
    ],
    benefits: [
      "401(k) with match and annual bonus eligibility",
      "Professional development budget and conference support",
      "Hybrid work flexibility after onboarding",
      "Comprehensive health, dental, and vision coverage"
    ]
  },
  {
    id: 'construction-manager',
    title: "Construction Manager",
    location: "Stamford, CT",
    type: "Full-time",
    department: "Operations",
    postedDate: "2025-07-24",
    summary: "Oversee field delivery for heavy civil projects with an emphasis on safety, schedule, and trade coordination.",
    description: "Our Construction Managers provide daily leadership on active sites, coordinating trade partners, monitoring progress, and ensuring work is executed safely while meeting design intent.",
    responsibilities: [
      "Plan and lead daily coordination meetings with contractors",
      "Maintain schedules, look-aheads, and progress reports",
      "Implement QA/QC and safety programs on-site",
      "Interface with owners, inspectors, and utilities"
    ],
    qualifications: [
      "10+ years of heavy civil construction experience",
      "OSHA 30 certification and strong safety track record",
      "Working knowledge of CPM scheduling and field documentation",
      "Ability to read/interpret civil, structural, and MEP drawings"
    ],
    benefits: [
      "Truck allowance and per diem for regional travel",
      "Company-paid training and certifications",
      "Annual performance bonus",
      "Robust health and wellness package"
    ]
  },
  {
    id: 'field-technician',
    title: "Field Technician",
    location: "Connecticut",
    type: "Full-time",
    department: "Field Operations",
    postedDate: "2025-07-18",
    summary: "Support surveying, inspections, and quality testing across multiple infrastructure projects.",
    description: "Field Technicians collect site data, perform materials testing, and support survey crews. You will rotate between transportation, water, and site projects, ensuring accurate field documentation.",
    responsibilities: [
      "Assist with topographic and construction staking surveys",
      "Perform concrete, soils, and asphalt field tests",
      "Document daily reports and photograph progress",
      "Support inspectors with punch lists and close-out"
    ],
    qualifications: [
      "1-3 years in construction testing or surveying preferred",
      "Ability to travel to project sites across CT",
      "Comfort with tablets and digital reporting tools",
      "Valid driver’s license with clean record"
    ],
    benefits: [
      "Paid training toward NICET/ACI certifications",
      "Use of company vehicle for field assignments",
      "Overtime opportunities",
      "Medical, dental, vision, and PTO from day one"
    ]
  },
  {
    id: 'project-coordinator',
    title: "Project Coordinator",
    location: "Stamford, CT",
    type: "Full-time",
    department: "Project Management",
    postedDate: "2025-07-10",
    summary: "Keep multi-discipline teams organized by managing submittals, budgets, and client communications.",
    description: "Project Coordinators support our PMs with proposal preparation, budget tracking, procurement, and client reporting. This role is ideal for detail-oriented professionals who thrive in fast-paced environments.",
    responsibilities: [
      "Prepare meeting agendas, minutes, and action logs",
      "Track budgets, invoices, and subcontractor agreements",
      "Manage document control and submittal logs",
      "Support proposal and marketing deliverables"
    ],
    qualifications: [
      "3+ years supporting engineering or construction teams",
      "Proficiency with MS Office and project management tools",
      "Excellent organizational and writing skills",
      "Experience with Procore or similar systems a plus"
    ],
    benefits: [
      "Hybrid schedule with modern Stamford HQ",
      "Professional development stipend",
      "401(k) with employer contribution",
      "Team wellness and volunteer days"
    ]
  },
  {
    id: 'safety-specialist',
    title: "Safety Specialist",
    location: "Connecticut",
    type: "Full-time",
    department: "Health & Safety",
    postedDate: "2025-07-05",
    summary: "Champion Redspire’s zero-compromise safety culture across transportation and water projects.",
    description: "Safety Specialists conduct field audits, lead training, and partner with project leadership to embed a proactive safety mindset. You will coach crews, analyze trends, and implement corrective actions.",
    responsibilities: [
      "Perform site inspections and craft corrective action plans",
      "Lead onboarding and toolbox talks",
      "Investigate incidents and develop lessons learned",
      "Maintain regulatory documentation and reporting"
    ],
    qualifications: [
      "5+ years of safety leadership in heavy civil construction",
      "OSHA 500/510 or CHST preferred",
      "Strong communication and coaching skills",
      "Knowledge of DOT, MSHA, and environmental regulations"
    ],
    benefits: [
      "Company vehicle and equipment allowance",
      "Tuition reimbursement for advanced certifications",
      "Annual safety performance bonus",
      "Full medical, dental, vision, and disability coverage"
    ]
  },
  {
    id: 'cad-bim-technician',
    title: "CAD/BIM Technician",
    location: "Stamford, CT / Hybrid",
    type: "Full-time",
    department: "Engineering",
    postedDate: "2025-06-30",
    summary: "Produce high-quality civil, structural, and utility models that power Redspire’s digital delivery.",
    description: "The CAD/BIM Technician develops 2D/3D deliverables for transportation, water, and site projects. You’ll collaborate closely with engineers to maintain accurate models, sheets, and clash-free coordination sets.",
    responsibilities: [
      "Develop Civil 3D surfaces, alignments, and plan/profile sheets",
      "Support BIM coordination sessions and resolve clashes",
      "Maintain model standards and template libraries",
      "Assist with renderings and visualization exports"
    ],
    qualifications: [
      "3+ years using Civil 3D, Revit, or Bentley OpenRoads",
      "Understanding of civil/structural design workflows",
      "Detail-oriented with strong file-management habits",
      "Ability to automate tasks with Dynamo/LISP is a plus"
    ],
    benefits: [
      "Hybrid work with ergonomic workstation stipend",
      "Software training and certification support",
      "401(k) match plus annual profit sharing",
      "Comprehensive healthcare and generous PTO"
    ]
  }
];

export const stats = [
  { value: "25+", label: "Years of Excellence" },
  { value: "500+", label: "Projects Delivered" },
  { value: "Extensive", label: "Infrastructure Built" },
  { value: "1,200+", label: "Team Members" }
];

export const awards = [
  {
    title: "ENR Top 200 Design Firm",
    year: "2025",
    description: "Recognized for multi-disciplinary delivery across transportation, water, and digital engineering.",
    icon: "Award"
  },
  {
    title: "ISO 9001:2015 Certified",
    year: "Renewed 2024",
    description: "Quality management system audited annually to support mission-critical public programs.",
    icon: "ShieldCheck"
  },
  {
    title: "ACEC Engineering Excellence",
    year: "2024",
    description: "Awarded for the Sundale Flood Resilience Upgrade and its integrated community benefits.",
    icon: "Star"
  },
  {
    title: "DBE / WBE Partnerships",
    year: "Ongoing",
    description: "Structured teaming that helps state agencies meet participation goals while elevating local firms.",
    icon: "Handshake"
  }
];

export const testimonials = [
  {
    quote:
      "Redspire brought a level of precision and communication that gave our council absolute confidence. The transit corridor opened ahead of schedule with unanimous community support.",
    author: "Alicia Moreno",
    title: "City Manager, Hartford Metro",
    photo: "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=400&q=80"
  },
  {
    quote:
      "From shop drawings to field engineering, their team was in lockstep with our contractors. The bridge change orders dropped by over 35% compared to prior projects.",
    author: "Damien Shah",
    title: "Program Executive, Northeast DOT",
    photo: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&q=80"
  },
  {
    quote:
      "Their Dallas studio integrates digital twin models with construction sequencing better than any firm we've partnered with. It’s a new benchmark for us.",
    author: "Melanie Chao",
    title: "VP of Capital Programs, LoneStar Mobility",
    photo: "https://images.unsplash.com/photo-1544723795-3fb6469f5b39?w=400&q=80"
  }
];

export const brandStory = `Redspire Civil Engineering began in the Czech Republic, where its founding philosophy was shaped by European engineering traditions — precision, discipline, and durability. Under the leadership of founder Ruben Wargner, the company quickly became known for its reliable civil works and straightforward project delivery.

As demand grew abroad, Redspire transitioned to the United States, establishing its permanent headquarters in Stamford, Connecticut. Today, Redspire continues to bring its legacy of continental engineering excellence to American infrastructure, combining innovation, sustainability, and community-focused development.

Our work begins long before concrete is poured or steel is set — it starts with understanding how people move, live, and grow. We focus on engineering that improves safety, mobility, and long-term resilience.`;

export const companyHistory = [
  { year: "1998", title: "Founded in Czech Republic", description: "Ruben Wargner establishes Redspire Civil Engineering in Prague, focusing on municipal infrastructure and bridge construction." },
  { year: "2003", title: "European Expansion", description: "Redspire grows across Central Europe, delivering highway upgrades and transit modernization projects." },
  { year: "2010", title: "International Recognition", description: "Company earns recognition for engineering excellence and safety standards across European markets." },
  { year: "2015", title: "U.S. Market Entry", description: "Redspire begins operations in the United States, pursuing infrastructure opportunities in the Northeast corridor." },
  { year: "2018", title: "Connecticut Headquarters", description: "Permanent headquarters established in Stamford, Connecticut, consolidating U.S. operations." },
  { year: "2025", title: "Continued Growth", description: "Redspire delivers landmark projects across Connecticut and the Northeast, expanding service capabilities." }
];

export const founderBio = {
  name: "Ruben Wargner",
  title: "Founder & Chief Strategy Officer",
  image: "/founder-silhouette.svg",
  imageAlt: "Founder Placeholder Image",
  isPlaceholder: true,
  fullBio: `Ruben Wargner is the visionary founder of Redspire Civil Engineering, bringing over three decades of civil engineering expertise spanning two continents. Born and educated in the Czech Republic, Ruben earned his civil engineering degree from the Czech Technical University in Prague, where he developed a deep appreciation for the European tradition of precision engineering and durable construction.

After graduating, Ruben spent his early career working on significant infrastructure projects across Central Europe, including highway rehabilitation programs, municipal water systems, and bridge construction. His work on the Vltava River crossing modernization project earned him recognition for innovative structural solutions and meticulous project management.

In 1998, driven by a desire to build something lasting, Ruben founded Redspire Civil Engineering in Prague. His leadership philosophy centered on three core principles: technical precision, transparent communication, and unwavering commitment to safety. Under his guidance, the company quickly established a reputation for delivering complex civil works on time and within budget.

As Redspire grew throughout Europe, Ruben recognized the opportunity to bring continental engineering excellence to the American market. In 2015, he led the company's expansion into the United States, ultimately establishing permanent headquarters in Stamford, Connecticut in 2018.

Today, as Chief Strategy Officer, Ruben oversees long-term vision, engineering culture, and innovation strategy. He remains deeply involved in major project planning and continues to mentor the next generation of civil engineers. His commitment to building infrastructure that serves communities for generations reflects the values he has championed throughout his career.

"Engineering is not just about structures," Ruben often says. "It's about understanding how people live and move, and building solutions that improve their lives for decades to come."`,
  highlights: [
    "Czech Technical University, Prague — Civil Engineering Degree",
    "30+ years of infrastructure development experience",
    "Led major European highway and bridge projects",
    "Founded Redspire Civil Engineering in 1998",
    "Spearheaded U.S. expansion and Connecticut headquarters establishment"
  ]
};

export const mission = "Redspire Civil Engineering exists to design and build infrastructure that strengthens communities, advances mobility, and stands the test of time. We combine technical precision with responsible innovation to deliver civil engineering solutions that support growth for generations.";
